import React from 'react';
import Header from './header';

import { URL, URL_SOCKET, TURN_1, TURN_2, TURN_3, TURN_4, hasSocketApiEncryptionKey } from '../variables';
import { connect } from 'react-redux';
import { mudarUser, logout, mudarProcesso, mudarSocket, mudarSalaScreen, mudarChatOpen, changeShowCall, changeConnect } from '../actions/AppActions';
import { Redirect, Link } from 'react-router-dom';
import io from 'socket.io-client';
import secureSocket from '../utils/secureSocket';

import moment from 'moment-timezone';
import Chat from './Chat';
import ReportAction from './ReportAction';
import ChatIndividual from './ChatIndividual';
import ReactTooltip from 'react-tooltip';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import HeaderSala from './HeaderSala';
import { getRoom, getRooms } from '../services/requests';
import SolicitacaoModal from './SolicitacaoModal';
import SweetAlert from 'react-bootstrap-sweetalert';
import MeetingRoom from "./Meet";
import ListStudents from './ListStudents';
import ValidationModal from './ValidationModal';
import { languages, getSelectedLanguage } from '../languages';
import Loader from '../components/Loader';

class Sala extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            msg: '',
            loading_screen: true,
            redirect: false,
            path: '/',
            salas: [],
            sala_select: {},
            number_online: [],
            alunos_m: [],
            comunicados: [],
            salas_ids: [],
            full_screen_open: false,
            aluno_fullscreen: -1,
            candidatos: [],
            width_candidato_box: 0,
            height_candidato_box: 0,
            alunoChat_select: {},
            candidato_selectAcao: {},
            show_modal_action: false,
            show_modal_chat_geral: false,
            show_modal_request: false,
            times_reconects: {},
            loading_sala: false,
            loading_alter_video: {},
            video_blink: {},
            video_blink_movement: {},
            number_line: [],
            requestSelect: null,
            message_warning: null,
            loadings_pause: {},
            show_chat_meet: false,
            list_open: false,
            open_validation_modal: false,
            validation_student_id: null,
            loadings_request_validations: {},
            hide_btns: {},
            mensagens_notificacao: {},
            validacao_notificacao: {},
            salas_numbers: {},
            chat_open_geral: false,
            show_notification:true,
            show_disconnected:false,
            open_candidate_menu: null,
            candidate_alert_details_open: {},
            candidate_screens: {},
            selectedLanguage: getSelectedLanguage(),
            processos_salas: [],
            current_processo_id: this.props.match.params.id,
            show_all_process_rooms: false

        }
        this.fullscreen_ref = React.createRef();
        this.audio_context_peers = {}
        this.list_peers = {};
        this.configuration = {
            iceServers: [
                { urls: "stun:stun.1.google.com:19302" },
                {
                    'urls': 'turn:turnserver.ontest.com.br:3478?transport=udp',
                    'credential': 'Coconuts69341228#',
                    'username': 'onteste_projetos'
                },
                // {
                //     'urls': 'turn:' + TURN_1 + ':3478?transport=udp',
                //     'credential': 'Coconuts69341228#',
                //     'username': 'onteste_projetos'
                // },
                // {
                //     'urls': 'turn:' + TURN_2 + ':3478?transport=udp',
                //     'credential': 'Coconuts69341228#',
                //     'username': 'onteste_projetos'
                // },
                // {
                //     'urls': 'turn:' + TURN_3 + ':3478?transport=udp',
                //     'credential': 'Coconuts69341228#',
                //     'username': 'onteste_projetos'
                // },
                // {
                //     'urls': 'turn:' + TURN_4 + ':3478?transport=udp',
                //     'credential': 'Coconuts69341228#',
                //     'username': 'onteste_projetos'
                // }

            ],
            sdpSemantics: 'unified-plan'
        };
        this.unmont = false;
        this.good_quality_student = {};
        this.timeout_request = {}
        this.last_alter_external = {}
        // this.videoRef=null;
    }
    handle_offer_sdp(offer) {
        let sdp = offer.sdp.split('\r\n');//convert to an concatenable array
        let new_sdp = '';
        let position = null;
        sdp = sdp.slice(0, -1); //remove the last comma ','
        for (let i = 0; i < sdp.length; i++) {//look if exists already a b=AS:XXX line
            if (sdp[i].match(/b=AS:/)) {
                position = i; //mark the position
            }
        }
        if (position) {
            sdp.splice(position, 1);//remove if exists
        }
        for (let i = 0; i < sdp.length; i++) {
            if (sdp[i].match(/m=video/)) {//modify and add the new lines for video
                new_sdp += sdp[i] + '\r\n' + 'b=AS:' + '24' + '\r\n';
            }
            else {
                if (sdp[i].match(/m=audio/)) { //modify and add the new lines for audio
                    new_sdp += sdp[i] + '\r\n' + 'b=AS:' + 48 + '\r\n';
                }
                else {
                    new_sdp += sdp[i] + '\r\n';
                }
            }
        }
        return new_sdp; //return the new sdp
    }
    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    getCandidateBoxSize() {
        let columns = 6;
        if (window.innerWidth < 600) {
            columns = 2;
        }
        else if (window.innerWidth < 900) {
            columns = 3;
        }
        let available_width = window.innerWidth;
        if (window.innerWidth >= 900 && (this.props.chat_open != -1 || this.state.list_open == true)) {
            available_width = window.innerWidth - 380;
        }
        let width_candidato_box = available_width / columns;
        let height_candidato_box = window.innerWidth < 900 ? width_candidato_box * 0.64 : (window.innerHeight - 0) / 4;
        return { width_candidato_box, height_candidato_box };
    }

    updateCandidateBoxSize() {
        this.setState(this.getCandidateBoxSize());
    }

    resetCurrentRoomStreams() {
        let keys = Object.keys(this.list_peers);
        for (let i = 0; i < keys.length; i++) {
            this.list_peers[keys[i]].close();
        }
        this.list_peers = {};
        this.audio_context_peers = {};

        if (this.state.sala_select.alunos != undefined) {
            for (let i = 0; i < Object.keys(this.state.sala_select.alunos).length; i++) {
                const aluno = this.state.sala_select.alunos[Object.keys(this.state.sala_select.alunos)[i]];
                if (aluno.videoRef.current != null) {
                    aluno.desconectado = true;
                    aluno.videoRef.current.srcObject = null;
                }
            }
        }
        this.good_quality_student = {};
    }

    prepareRoomsResponse(resp) {
        let salas_ids = [];
        let salas_numbers = {};
        let candidatos = [];
        let comunicados = [];

        for (let i = 0; i < resp.comunicados.length; i++) {
            resp.comunicados[i].send = true;
            comunicados.push(resp.comunicados[i]);
        }

        for (let i = 0; i < resp.salas.length; i++) {
            let alunos = {};
            salas_ids.push(resp.salas[i].id);
            salas_numbers[resp.salas[i].id] = resp.salas[i].numero;
            for (let j = 0; j < resp.salas[i].alunos.length; j++) {
                candidatos.push({ name: resp.salas[i].alunos[j].name + ' - Sala ' + resp.salas[i].numero, id: resp.salas[i].alunos[j].id, sala_id: resp.salas[i].id });
                alunos[resp.salas[i].alunos[j].id] = resp.salas[i].alunos[j];
                alunos[resp.salas[i].alunos[j].id].videoRef = React.createRef();
                alunos[resp.salas[i].alunos[j].id].bar1 = React.createRef();
                alunos[resp.salas[i].alunos[j].id].bar2 = React.createRef();
                alunos[resp.salas[i].alunos[j].id].bar3 = React.createRef();
                alunos[resp.salas[i].alunos[j].id].desconectado = true;
            }
            resp.salas[i].alunos = alunos;
        }

        candidatos = candidatos.sort(function (a, b) { return a.name.localeCompare(b.name); });

        return { salas_ids, salas_numbers, candidatos, comunicados };
    }

    getAllProcessRoomIds() {
        const roomIds = [];

        for (let i = 0; i < this.state.processos_salas.length; i++) {
            const salas = this.state.processos_salas[i].salas || [];
            for (let j = 0; j < salas.length; j++) {
                if (roomIds.indexOf(salas[j].id) === -1) {
                    roomIds.push(salas[j].id);
                }
            }
        }

        return roomIds;
    }

    getSocketSubscribedRoomIds() {
        if (this.state.show_all_process_rooms === true) {
            return this.getAllProcessRoomIds();
        }

        return this.state.salas_ids;
    }

    joinSelectedSocketRoom(last_sala) {
        if (this.socket == null || this.state.sala_select.id == undefined) {
            return;
        }
        this.socket.emit('change_room', {
            name: 'Admin',
            sala_id: this.state.sala_select.id,
            salas_ids: this.getSocketSubscribedRoomIds(),
            last_sala,
            last_salas_ids: this.last_salas_ids_for_socket || this.getSocketSubscribedRoomIds(),
            faculdade_id: this.props.faculdade.id,
            processo_id: this.state.current_processo_id,
            admin_id: this.admin_id
        });
        this.last_salas_ids_for_socket = null;
    }

    toggleAllProcessRooms(checked) {
        if (this.state.loading_sala === true || this.state.loading_screen === true) {
            return;
        }

        this.last_salas_ids_for_socket = this.getSocketSubscribedRoomIds();
        this.setState({ show_all_process_rooms: checked }, () => {
            this.joinSelectedSocketRoom(this.state.sala_select.id);
        });
    }

    handleCandidateMenuOutsideClick(event) {
        if (this.state.open_candidate_menu == null) {
            return;
        }

        const target = event.target;
        if (target != null && target.closest != null && (target.closest('.fiscal-candidate-menu') || target.closest('.fiscal-candidate-menu-toggle'))) {
            return;
        }

        this.setState({ open_candidate_menu: null });
    }


    componentDidMount() {
        // document.getElementById('header_page').classList.add('mouse_come_here');
        // this.mouseEvent = (function (e) {
        //     if (e.clientY < 70 && this.props.chat_open == false) {
        //         document.getElementById('header_page').classList.add('visible');
        //         document.getElementById('header_page').classList.remove('mouse_come_here');
        //     }
        //     else {
        //         document.getElementById('header_page').classList.remove('visible');
        //         document.getElementById('header_page').classList.add('mouse_come_here');
        //     }
        // }).bind(this);
        // window.addEventListener('mousemove', this.mouseEvent);

        this.props.mudarChatOpen(-1);
        this.languageListener = () => this.setState({ selectedLanguage: getSelectedLanguage() });
        window.addEventListener('fiscal_language_change', this.languageListener);
        this.updateCandidateBoxSize();
        this.resizeEvent = (function (event) {
            console.log(window.innerWidth);
            console.log(window.innerHeight);
            this.updateCandidateBoxSize();

            console.log(event);
        }).bind(this);
        window.addEventListener('resize', this.resizeEvent, true);
        this.candidateMenuOutsideClick = this.handleCandidateMenuOutsideClick.bind(this);
        document.addEventListener('mousedown', this.candidateMenuOutsideClick);

        this.props.mudarSalaScreen(true);
        this.get_salas(this.props.match.params.id);

    }

    componentDidUpdate(props, state) {
        if (props.chat_open != this.props.chat_open || this.state.list_open != state.list_open) {
            this.updateCandidateBoxSize();
        }
        if (state.loading_screen == true && this.state.loading_screen == false) {
            setTimeout(() => this.updateCandidateBoxSize(), 0);
        }

        return;
        if (this.state.sala_select.alunos != undefined && state.sala_select.alunos != undefined) {
            console.log('entrou');
            let actual_ids = Object.values(this.state.sala_select.alunos).sort(this.sort_by_online.bind(this)).filter((item, id) => this.state.number_online.includes(item.id.toString())).map((item, id) => item.id);
            let last_ids = Object.values(state.sala_select.alunos).sort(this.sort_by_online.bind(this)).filter((item, id) => state.number_online.includes(item.id.toString())).map((item, id) => item.id);
            let arrays_equal = true;
            // console.log(actual_ids)
            // console.log(last_ids)
            if (actual_ids.length != last_ids.length) {
                arrays_equal = false;
            }
            else {
                for (let i = 0; i < actual_ids.length; i++) {
                    if (actual_ids[i] != last_ids[i]) {
                        arrays_equal = false;
                        break
                    }
                }
            }
            if (arrays_equal == false) {
                // console.log('Diferente');
                Object.values(this.state.sala_select.alunos).map((item, id) => {
                    try {

                        if (document.getElementById(item.id) != null) {
                            document.getElementById(item.id).srcObject = item.stream
                            if (!this.state.number_online.includes(item.id.toString())) {
                                if (this.state.sala_select.alunos[item.id].bar1 != undefined && this.state.sala_select.alunos[item.id].bar1.current != null) {
                                    this.state.sala_select.alunos[item.id].bar1.current.hidden = true;
                                }
                                if (this.state.sala_select.alunos[item.id].bar2 != undefined && this.state.sala_select.alunos[item.id].bar2.current != null) {
                                    this.state.sala_select.alunos[item.id].bar2.current.hidden = true;
                                }
                                if (this.state.sala_select.alunos[item.id].bar3 != undefined && this.state.sala_select.alunos[item.id].bar3.current != null) {
                                    this.state.sala_select.alunos[item.id].bar3.current.hidden = true;
                                }
                            }
                            else if (this.audio_context_peers[item.id] != undefined) {
                                if (this.audio_context_peers[item.id].isInTime != true) {
                                    if (this.state.sala_select.alunos[item.id].bar1 != undefined && this.state.sala_select.alunos[item.id].bar1.current != null) {
                                        this.state.sala_select.alunos[item.id].bar1.current.hidden = true;
                                    }
                                    if (this.state.sala_select.alunos[item.id].bar2 != undefined && this.state.sala_select.alunos[item.id].bar2.current != null) {
                                        this.state.sala_select.alunos[item.id].bar2.current.hidden = true;
                                    }
                                    if (this.state.sala_select.alunos[item.id].bar3 != undefined && this.state.sala_select.alunos[item.id].bar3.current != null) {
                                        this.state.sala_select.alunos[item.id].bar3.current.hidden = true;
                                    }
                                }
                                else {
                                    if (this.state.sala_select.alunos[item.id].bar1 != undefined && this.state.sala_select.alunos[item.id].bar1.current != null) {
                                        this.state.sala_select.alunos[item.id].bar1.current.hidden = false;
                                    }
                                    if (this.state.sala_select.alunos[item.id].bar2 != undefined && this.state.sala_select.alunos[item.id].bar2.current != null) {
                                        this.state.sala_select.alunos[item.id].bar2.current.hidden = false;
                                    }
                                    if (this.state.sala_select.alunos[item.id].bar3 != undefined && this.state.sala_select.alunos[item.id].bar3.current != null) {
                                        this.state.sala_select.alunos[item.id].bar3.current.hidden = false;
                                    }
                                }
                            }
                            else {
                                if (this.state.sala_select.alunos[item.id].bar1 != undefined && this.state.sala_select.alunos[item.id].bar1.current != null) {
                                    this.state.sala_select.alunos[item.id].bar1.current.hidden = true;
                                }
                                if (this.state.sala_select.alunos[item.id].bar2 != undefined && this.state.sala_select.alunos[item.id].bar2.current != null) {
                                    this.state.sala_select.alunos[item.id].bar2.current.hidden = true;
                                }
                                if (this.state.sala_select.alunos[item.id].bar3 != undefined && this.state.sala_select.alunos[item.id].bar3.current != null) {
                                    this.state.sala_select.alunos[item.id].bar3.current.hidden = true;
                                }
                            }
                        }
                        else {
                            if (this.state.sala_select.alunos[item.id].bar1 != undefined && this.state.sala_select.alunos[item.id].bar1.current != null) {
                                this.state.sala_select.alunos[item.id].bar1.current.hidden = true;
                            }
                            if (this.state.sala_select.alunos[item.id].bar2 != undefined && this.state.sala_select.alunos[item.id].bar2.current != null) {
                                this.state.sala_select.alunos[item.id].bar2.current.hidden = true;
                            }
                            if (this.state.sala_select.alunos[item.id].bar3 != undefined && this.state.sala_select.alunos[item.id].bar3.current != null) {
                                this.state.sala_select.alunos[item.id].bar3.current.hidden = true;
                            }
                        }
                    }
                    catch (e) {
                        console.log(e);
                    }
                })
            }

        }
    }

    componentWillUnmount() {
        // window.removeEventListener('mousemove', this.mouseEvent)
        window.removeEventListener('resize', this.resizeEvent, true);
        if (this.languageListener) {
            window.removeEventListener('fiscal_language_change', this.languageListener);
        }
        if (this.candidateMenuOutsideClick) {
            document.removeEventListener('mousedown', this.candidateMenuOutsideClick);
        }
        this.props.mudarSalaScreen(false);
        this.props.mudarChatOpen(-1);

        clearTimeout(this.logs_timeout);
        clearTimeout(this.timeout_numbers);
        if (this.socket != undefined) {
            this.socket.close();
        }
        this.props.mudarSocket(null);
        this.unmont = true;

    }

    async get_salas(id) {
        this.setState({ loading_screen: true });
        getRooms(id, this.props.token).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);

                    // this.props.mudarLoadingHome(false);
                    setTimeout(() => {
                        this.get_salas(this.state.current_processo_id);
                    }, 5000);
                }
                else if (this.unmont == false) {
                    this.props.mudarProcesso(resp.processo);
                    if (resp.salas.length == 0) {
                        this.setState({ redirect: true });
                        return;
                    }
                    const prepared = this.prepareRoomsResponse(resp);
                    this.setState({ current_processo_id: resp.processo.id, processos_salas: resp.processos_salas || [], candidatos: prepared.candidatos, salas_numbers: prepared.salas_numbers, loading_screen: false, salas_ids: prepared.salas_ids, comunicados: prepared.comunicados, salas: resp.salas, sala_select: { ...resp.salas[0] }, video_blink: {}, video_blink_movement: {}, candidate_screens: {}, alunos_m: resp.alunos }, () => {
                        clearTimeout(this.timeout_numbers);
                        this.get_numbers();
                    });
                    if (this.socket == null) {
                        this.video_init();
                    }
                    this.logs_timeout = setTimeout(() => {
                        this.salvar_log();
                    }, 60000);
                }




            } catch (err) {
                console.log(err);
                // this.props.mudarLoadingHome(false);
                setTimeout(() => {
                    this.get_salas(this.state.current_processo_id);
                }, 5000);

            }

        })
            .catch((err) => {
                console.log(err);
                // this.props.mudarLoadingHome(false);
                setTimeout(() => {
                    this.get_salas(this.state.current_processo_id);
                }, 5000);
            });
    }



    async get_sala(id, sala_id, last_sala) {
        this.setState({ loading_sala: true });
        getRoom(id, sala_id, this.props.token).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);

                    // this.props.mudarLoadingHome(false);
                    setTimeout(() => {
                        this.get_sala(this.state.current_processo_id, sala_id);
                    }, 5000);
                }
                else if (this.unmont == false) {
                    if (sala_id == this.state.sala_select.id) {
                        this.props.mudarProcesso(resp.processo);
                        if (resp.salas.length == 0) {
                            this.setState({ redirect: true });
                            return;
                        }
                        const prepared = this.prepareRoomsResponse(resp);
                        const selectedSala = resp.salas.find((sala) => sala.id == sala_id) || resp.salas[0];
                        this.setState({ current_processo_id: resp.processo.id, processos_salas: resp.processos_salas || this.state.processos_salas, salas_ids: prepared.salas_ids, salas_numbers: prepared.salas_numbers, candidatos: prepared.candidatos, comunicados: prepared.comunicados, salas: resp.salas, alunoChat_select: {}, loading_sala: false, sala_select: { ...selectedSala }, video_blink: {}, video_blink_movement: {}, candidate_screens: {}, alunos_m: { ...this.state.alunos_m, ...resp.alunos } }, () => {
                            console.log('teste');
                            if (sala_id == this.state.sala_select.id) {
                                clearTimeout(this.timeout_numbers);
                                this.get_numbers();
                                // console.log({ name: 'Admin',  sala_id: this.state.sala_select, last_sala, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id })
                                this.joinSelectedSocketRoom(last_sala);

                            }

                        });
                    }
                }




            } catch (err) {
                console.log(err);
                // this.props.mudarLoadingHome(false);
                setTimeout(() => {
                    this.get_sala(this.state.current_processo_id, sala_id);
                }, 5000);

            }

        })
            .catch((err) => {
                console.log(err);
                // this.props.mudarLoadingHome(false);
                setTimeout(() => {
                    this.get_sala(this.state.current_processo_id, sala_id);
                }, 5000);
            });
    }

    sort_by_online(a, b) {
        let number_online = [...this.state.number_online];
        // console.log(a.id+' '+b.id)
        // console.log(number_online.includes(a.id.toString()))
        // console.log(number_online.includes(b.id.toString()))
        // console.log(number_online.includes(a.id.toString()) < number_online.includes(b.id.toString()))
        // console.log(number_online.includes(b.id.toString()) > number_online.includes(a.id.toString()))
        // console.log(number_online)


        if (number_online.includes(a.id.toString()) > number_online.includes(b.id.toString())) {
            return -1;
        }
        if (number_online.includes(b.id.toString()) < number_online.includes(a.id.toString())) {
            return 1;
        }
        return 0;
    }

    draw_peer(id, uuid) {
        let user_id = id;
        if (this.audio_context_peers[user_id]['id'] != uuid) {
            return;
        }
        if (this.audio_context_peers[user_id]['context'].state != 'running') {
            this.audio_context_peers[user_id]['context'].resume();
        }

        if (
            this.state.sala_select.alunos[id]
        ) {

            let bar1 = this.state.sala_select.alunos[id].bar1.current;
            let bar2 = this.state.sala_select.alunos[id].bar2.current;
            let bar3 = this.state.sala_select.alunos[id].bar3.current;
            // console.log(this.state.sala_select.alunos[id])
            // let bar_peer = document.getElementById('indicator'+id);
            // let audio_elem = document.getElementById('audio' + id);

            if (bar1 == null || bar2 == null || bar3 == null || !this.state.number_online.includes(id.toString())) {
                // console.log('encerrou ' + id)
                clearTimeout(this.audio_context_peers[id].timeout);
                if (bar1 != null) {
                    // console.log('hidden')
                    // bar1.hidden = true;
                    // bar2.hidden = true;
                    // bar3.hidden = true;
                    if (this.state.sala_select.alunos[id].bar1 != undefined && this.state.sala_select.alunos[id].bar1.current != null) {
                        this.state.sala_select.alunos[id].bar1.current.hidden = true;
                    }
                    if (this.state.sala_select.alunos[id].bar2 != undefined && this.state.sala_select.alunos[id].bar2.current != null) {
                        this.state.sala_select.alunos[id].bar2.current.hidden = true;
                    }
                    if (this.state.sala_select.alunos[id].bar3 != undefined && this.state.sala_select.alunos[id].bar3.current != null) {
                        this.state.sala_select.alunos[id].bar3.current.hidden = true;
                    }
                }

                return 0;
            }
            // var drawVisual = requestAnimationFrame(()=>draw_peer(id));
            this.audio_context_peers[id]['analyser'].getByteTimeDomainData(this.audio_context_peers[id]['dataArray']);

            var sliceWidth = 300 * 1.0 / this.audio_context_peers[id]['bufferLength'];
            var x = 0;
            let max = 0;

            for (var i = 0; i < this.audio_context_peers[id]['bufferLength']; i++) {
                var v = this.audio_context_peers[id]['dataArray'][i] / 128.0;
                if (((v - 0.93) * 100) > 10) {
                    bar1.hidden = false;
                    bar2.hidden = false;
                    bar3.hidden = false;
                    this.audio_context_peers[id].isInTime = true;
                    clearTimeout(this.audio_context_peers[id].timeout);
                    this.audio_context_peers[id].timeout = setTimeout(() => {
                        this.audio_context_peers[id].isInTime = false;
                        let bar1 = this.state.sala_select.alunos[id]?.bar1?.current;
                        let bar2 = this.state.sala_select.alunos[id]?.bar2?.current;
                        let bar3 = this.state.sala_select.alunos[id]?.bar3?.current;
                        if (bar1 != null) {
                            bar1.hidden = true;
                            bar2.hidden = true;
                            bar3.hidden = true;
                        }
                    }, 10000);
                }
                // else{
                //     bar1[0].hidden=true;
                //     bar2[0].hidden=true;
                //     bar3[0].hidden=true;
                // }
                // if((v-1)>0)
                //     bar_peer.style.clipPath='circle(40%)';
                // else
                //     bar_peer.style.clipPath='circle(30%)';


                if (bar1 != null && bar2 != null && bar3 != null) {
                    // for (let j = 0; j < bar1.length; j++) {
                    //     bar1[j].style.height = bar2[0].style.height;
                    // }
                    bar1.style.height = bar2.style.height;
                    bar2.style.height = bar3.style.height;
                    if (((v - 0.93) * 100) > 15) {
                        bar3.style.height = '15px';
                    }
                    else {
                        bar3.style.height = ((v - 0.93) * 100) + 'px';
                    }

                    if (((v - 0.93) * 100) > max) {
                        max = ((v - 0.93) * 100);
                    }
                }

            }
            setTimeout(() => {
                this.draw_peer(id, uuid)
            }, 300);
        }


    };


    salvar_log() {
        fetch(`${URL}api/fiscal/salvar_log?screen=sala&sala_numero=${this.state.sala_select.numero}&sala_id=${this.state.sala_select.id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {
                    if (this.unmont == false) {
                        this.logs_timeout = setTimeout(() => {
                            this.salvar_log();
                        }, 60000);
                    }
                }
            } catch (err) {
                console.log(err);
                if (this.unmont == false) {
                    this.logs_timeout = setTimeout(() => {
                        this.salvar_log();
                    }, 60000);
                }

            }

        })
            .catch((err) => {
                console.log(err);
                if (this.unmont == false) {
                    this.logs_timeout = setTimeout(() => {
                        this.salvar_log();
                    }, 60000);
                }
            });
    }

    onIceCandidate(peer, evt, aluno_id,external) {
        if (evt.candidate) {
            this.socket.emit("candidate_to_aluno", JSON.stringify({ external, "candidate": evt.candidate, admin_id: this.admin_id, faculdade_id: this.props.faculdade.id, aluno_id: aluno_id }));
        }
    }

    video_init() {
        this.admin_id = this.uuidv4();
        const hasEncryptedSocket = hasSocketApiEncryptionKey();
        const socketQuery = { token: this.props.token };
        if (hasEncryptedSocket) {
            socketQuery.encrypted_socket = 'true';
        }
        const socket = io.connect(URL_SOCKET, { "transports": ['websocket'], query: socketQuery });
        this.socket = hasEncryptedSocket ? secureSocket(socket) : socket;
        this.props.mudarSocket(this.socket);

        // socket.emit("join", {name:'Admin',sala_id:sala_id,faculdade_id:faculdade_id});
        this.socket.on("connect", function (client) {
            this.props.changeConnect(true);

            // this.socket.emit('join_stream_admin', { sala_id: this.state.sala_select.id, admin_id: this.admin_id, faculdade_id: this.props.faculdade.id })
            this.socket.emit("join", { name: 'Admin', salas_ids: this.getSocketSubscribedRoomIds(), sala_id: this.state.sala_select.id, faculdade_id: this.props.faculdade.id, processo_id: this.state.current_processo_id, admin_id: this.admin_id });

        }.bind(this));

        this.socket.on('candidate_screen', function (data) {
            if (data == null || data.aluno_id == null) {
                return;
            }
            const video_blink = { ...this.state.video_blink };
            if (data.candidate_inside_screen == true || data.screen !== 'evaluation') {
                video_blink[data.aluno_id] = false;
            }
            this.setState({
                video_blink,
                candidate_screens: {
                    ...this.state.candidate_screens,
                    [data.aluno_id]: {
                        ...(this.state.candidate_screens[data.aluno_id] || {}),
                        ...data
                    }
                }
            });
        }.bind(this));

        this.socket.on('external_camera_status', function (data) {
            if (data == null || data.aluno_id == null) {
                return;
            }
            this.setState({
                candidate_screens: {
                    ...this.state.candidate_screens,
                    [data.aluno_id]: {
                        ...(this.state.candidate_screens[data.aluno_id] || {}),
                        ...data
                    }
                }
            });
        }.bind(this));

        this.socket.on("candidate", function (msg) {
            // console.log("candidate received");
            let id = JSON.parse(msg).aluno_id;
            if(JSON.parse(msg).external==true){
                id+='external_'+id;
            }
            if (this.list_peers[id] != undefined && this.list_peers[id].connectionState != 'closed') {
                this.list_peers[id].addIceCandidate(new RTCIceCandidate(JSON.parse(msg).candidate));
            }

        }.bind(this));

        this.socket.on("sdp" + this.admin_id, function (msg) {
            console.log("sdp received");
            let data = JSON.parse(msg)
            let id = data.aluno_id;
            let id_ = data.aluno_id;

            if(data.external==true){
                id+='external_'+id;
            }
            if (this.list_peers[id] != undefined) {
                this.list_peers[id].close();
            }
            this.list_peers[id] = new RTCPeerConnection(this.configuration);

            this.list_peers[id].onicecandidate = function (evt) {
                if (!evt.candidate) return;
                // console.log("onicecandidate called");
                this.onIceCandidate(this.list_peers[id], evt, id_,data.external);
            }.bind(this);

            this.list_peers[id].onaddstream = function (evt) {
                console.log("onaddstream called",data);
                if (this.state.sala_select.alunos[id_] != undefined && data.external!=true) {

                    const aluno = this.state.sala_select.alunos[id_];
                    aluno.stream = evt.stream;

                    let user_id = id;
                    this.audio_context_peers[user_id] = {}
                    this.audio_context_peers[user_id]['context'] = new AudioContext();
                    this.audio_context_peers[user_id]['analyser'] = this.audio_context_peers[user_id]['context'].createAnalyser();
                    this.audio_context_peers[user_id]['frequencyData'] = null;
                    this.audio_context_peers[user_id]['source'] = this.audio_context_peers[user_id]['context'].createMediaStreamSource(this.state.sala_select.alunos[id].stream);
                    this.audio_context_peers[user_id]['source'].connect(this.audio_context_peers[user_id]['analyser']);
                    this.audio_context_peers[user_id]['gainNode'] = this.audio_context_peers[user_id]['context'].createGain();
                    this.audio_context_peers[user_id]['gainNode'].gain.value = 0.1; // setting it to 10%
                    this.audio_context_peers[user_id]['gainNode'].connect(this.audio_context_peers[user_id]['context'].destination);
                    // analyser.connect(context.destination);

                    this.audio_context_peers[user_id]['context'].resume()
                    this.audio_context_peers[user_id]['analyser'].fftSize = 32;
                    this.audio_context_peers[user_id]['bufferLength'] = this.audio_context_peers[user_id]['analyser'].frequencyBinCount;
                    this.audio_context_peers[user_id]['dataArray'] = new Uint8Array(this.audio_context_peers[user_id]['bufferLength']);
                    this.audio_context_peers[user_id]['analyser'].getByteTimeDomainData(this.audio_context_peers[user_id]['dataArray']);
                    this.audio_context_peers[user_id].id = this.uuidv4()
                    // this.audio.srcObject = evt.stream
                    this.draw_peer(user_id, this.audio_context_peers[user_id].id);

                    console.log('full_screen_added1')
                    // console.log(this.state.aluno_fullscreen,Object.values(this.state.sala_select.alunos)[this.state.aluno_fullscreen]?.id,id)
                    if (this.last_alter_external[id_] != 'external') {
                        aluno.videoRef.current.srcObject = evt.stream;
                    }

                    if (this.state.aluno_fullscreen != -1 && this.state.aluno_fullscreen == id && this.last_alter_external[id_] != 'external') {
                        console.log('full_screen_added2')
                        console.log(evt.stream)
                        this.fullscreen_ref.current.srcObject = evt.stream;

                    }
                }
                else if((this.state.sala_select.alunos[id_] != undefined && data.external==true)){
                    const aluno = this.state.sala_select.alunos[id_];
                    aluno.stream_external = evt.stream;
                    if (this.last_alter_external[id_] == 'external') {
                        aluno.videoRef.current.srcObject = evt.stream;
                        if (this.state.aluno_fullscreen != -1 && this.state.aluno_fullscreen == id_) {
                            this.fullscreen_ref.current.srcObject = evt.stream;
                        }
                    }

                    console.log('Connect_external')
                }
                // document.getElementById("video_tag" + data.aluno_id).srcObject = evt.stream;
            }.bind(this);
            // list_peers[id].oniceconnectionstatechange = function() {
            //     console.log(list_peers[id].iceConnectionState);
            // }
            // list_peers[id].onconnectionstatechange = function() {
            //     console.log(list_peers[id].connectionState);
            // }   
            var sessionDesc = new RTCSessionDescription(data.sdp);
            this.list_peers[id].setRemoteDescription(sessionDesc);
            this.list_peers[id].createAnswer().then(function (sdp) {
                if (this.good_quality_student[id] != true) {
                    sdp.sdp = this.handle_offer_sdp(sdp)
                }
                else {
                    console.log('NAO ENTROU SDP')
                }
                console.log('anwser sdp');
                this.list_peers[id].setLocalDescription(new RTCSessionDescription(sdp));
                this.socket.emit("answer", JSON.stringify({external:data.external, "sdp": sdp, admin_id: this.admin_id, aluno_id: data.aluno_id, faculdade_id: this.props.faculdade.id }));
            }.bind(this)).catch(function (e) {
                console.log(e);
            });
        }.bind(this));

        this.socket.on("number_line" + this.props.faculdade.id, function (data) {
            if (data.sala_id == this.state.sala_select.id) {
                this.setState({ number_line: data.number_line ? data.number_line : this.state.number_line })

            }
        }.bind(this))

        this.socket.on("aluno_desconectou", function (data) {
            // console.log(video);
            if (data.aluno_id != undefined) {
                if (data.sala_id == this.state.sala_select.id && !data.number.includes( data.aluno_id.toString())) {

                    let sala_select = this.state.sala_select;
                    console.log(data);
                    console.log('desconectou');
                    if (this.state.aluno_fullscreen != -1 && this.state.aluno_fullscreen == data.aluno_id) {
                        this.fullscreen_ref.current.srcObject = null;
                    }
                    sala_select.alunos[data.aluno_id].desconectado = true;
                    if (sala_select.alunos[data.aluno_id].videoRef.current != null) {
                        sala_select.alunos[data.aluno_id].videoRef.current.srcObject = null;
                    }
                    let video_blink = { ...this.state.video_blink }
                    let video_blink_movement = { ...this.state.video_blink_movement }

                    video_blink[data.aluno_id] = false;
                    video_blink_movement[data.aluno_id] = false;
                    console.log(video_blink_movement)
                    this.setGoodQualityStudent(data.aluno_id, false);
                    const candidate_screens = this.mergeCandidateScreensSnapshot(data.candidate_screens);

                    this.setState({ number_online: data.number, number_line: data.number_line ? data.number_line : this.state.number_line, sala_select, video_blink, video_blink_movement, candidate_screens })
                }
                else if(data.number.includes( data.aluno_id.toString())){
                    this.state.sala_select.alunos[data.aluno_id].videoRef.current.srcObject = this.state.sala_select.alunos[data.aluno_id].stream;
                    this.setState({ number_online: data.number })

                }
                else {
                    this.setState({ number_online: data.number })
                }
            }
            else {
                this.setState({
                    number_online: data.number,
                    number_line: data.number_line ? data.number_line : this.state.number_line,
                    video_blink: {},
                    video_blink_movement: {},
                    candidate_screens: this.mergeCandidateScreensSnapshot(data.candidate_screens, {}, true)
                })
            }
        }.bind(this))

        this.socket.on("aluno_conectou", function (data) {
            console.log(data);
            // $('#online_number').text(data.number);
            if (data.aluno_id != undefined) {

                if (data.sala_id == this.state.sala_select.id) {
                    let video_blink = { ...this.state.video_blink }
                    let video_blink_movement = { ...this.state.video_blink_movement }

                    let keys = Object.keys(video_blink);
                    for (let i = 0; i < keys.length; i++) {
                        if (!data.number.includes(keys[i].toString())) {
                            video_blink[keys[i]] = false;
                        }
                    }

                    keys = Object.keys(video_blink_movement);
                    for (let i = 0; i < keys.length; i++) {
                        if (!data.number.includes(keys[i].toString())) {
                            video_blink_movement[keys[i]] = false;
                        }
                    }

                    let sala_select = this.state.sala_select;
                    sala_select.alunos[data.aluno_id].desconectado = false
                    const candidate_inside_screen = data.candidate_inside_screen !== undefined ? data.candidate_inside_screen == true : true;
                    const candidate_ip = data.candidate_ip || data.ip || null;
                    const candidate_screens = this.mergeCandidateScreensSnapshot(data.candidate_screens);
                    this.setState({
                        number_online: data.number,
                        number_line: data.number_line,
                        sala_select,
                        video_blink,
                        video_blink_movement,
                        candidate_screens: {
                            ...candidate_screens,
                            [data.aluno_id]: {
                                ...(candidate_screens[data.aluno_id] || {}),
                                aluno_id: data.aluno_id,
                                sala_id: data.sala_id,
                                candidate_inside_screen,
                                ...(candidate_ip != null ? { candidate_ip } : {})
                            }
                        }
                    })
                }
                else {
                    this.setState({ number_online: data.number })
                }

            }
            else {
                this.setState({
                    number_online: data.number,
                    number_line: data.number_line,
                    video_blink: {},
                    video_blink_movement: {},
                    candidate_screens: this.mergeCandidateScreensSnapshot(data.candidate_screens, {}, true)
                })
            }
        }.bind(this))

        this.socket.on('disconnect', function () {
            console.log('desconectou socket')
            this.props.changeConnect(false);

        }.bind(this));

        //Send the ICE Candidate to the remote peer
        clearTimeout(this.timeout_numbers);
        this.timeout_numbers = setTimeout(() => {
            this.get_numbers();
        }, 300000);

    }

    get_numbers() {
        if (this.socket != null) {
            this.socket.emit("get_numbers", { faculdade_id: this.props.faculdade.id, admin_id: this.admin_id, sala_id: this.state.sala_select.id });
        }
        clearTimeout(this.timeout_numbers);
        this.timeout_numbers = setTimeout(() => {
            this.get_numbers();
        }, 300000);
    }

    selectRoom(item) {
        if (this.state.loading_sala === true || item.id == this.state.sala_select.id) {
            return;
        }

        let last_sala = this.state.sala_select.id;
        this.resetCurrentRoomStreams();
        this.props.mudarChatOpen(-1);

        this.setState({ sala_select: item, alunoChat_select: {}, video_blink: {}, video_blink_movement: {}, candidate_screens: {}, list_open: false }, () => {
            this.get_sala(this.state.current_processo_id, item.id, last_sala);
        });
    }

    selectProcess(processo, sala = null) {
        if (processo == null || this.state.loading_sala === true || this.state.loading_screen === true) {
            return;
        }

        const firstSala = sala || (processo.salas && processo.salas.length > 0 ? processo.salas[0] : null);
        if (firstSala == null) {
            return;
        }

        const last_sala = this.state.sala_select.id;
        this.last_salas_ids_for_socket = [...this.getSocketSubscribedRoomIds()];
        this.resetCurrentRoomStreams();
        this.props.mudarChatOpen(-1);
        this.props.history.replace('/sala/' + processo.id);

        this.setState({
            current_processo_id: processo.id,
            sala_select: { ...firstSala, alunos: {} },
            salas: [],
            salas_ids: [],
            alunos_m: [],
            candidatos: [],
            video_blink: {},
            video_blink_movement: {},
            candidate_screens: {},
            list_open: false,
            loading_sala: true
        }, () => {
            this.get_sala(processo.id, firstSala.id, last_sala);
        });
    }

    findProcessRoomBySalaId(salaId) {
        for (let i = 0; i < this.state.processos_salas.length; i++) {
            const processo = this.state.processos_salas[i];
            const sala = (processo.salas || []).find((item) => item.id == salaId);
            if (sala != null) {
                return { processo, sala };
            }
        }

        return null;
    }

    receive_all(uuid, sala_id, aluno_id) {
        fetch(`${URL}api/fiscal/receive_all_fiscal`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                uuid,
                sala_id, aluno_id
            })
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {

                }
            } catch (err) {
                console.log(err);
            }

        })
            .catch((err) => {
                console.log(err);
            });
    }

    sendReceive(aluno) {
        let aluno2 = this.state.alunos_m[aluno.id];
        if (aluno2.mensagens.length > 0) {
            this.props.socket.emit('msg_receive_aluno', { sala_id: aluno2.sala_id, aluno_id: aluno2.id, uuid: aluno2.mensagens[aluno2.mensagens.length - 1].uuid, faculdade_id: this.props.faculdade.id });
            this.receive_all(aluno2.mensagens[aluno2.mensagens.length - 1].uuid, aluno2.sala_id, aluno2.id);
        }
        let alunos = { ...this.state.alunos_m };
        alunos[aluno2.id].counter = 0;
        this.setState({ alunos_m: alunos, alunoChat_select: { ...alunos[aluno2.id] } });
    }

    send_message(msg) {
        let uid_msg = this.uuidv4();

        if (msg != null && msg != '' && msg.replace(/ /g, '') != '') {
            this.props.socket.emit("send_msg", { processo_id: this.props.processo.id, msg: msg, sala_id: this.state.alunoChat_select.sala_id, aluno_id: this.state.alunoChat_select.id, nome_chat: this.props.user.name, id_msg: uid_msg, admin_id: this.admin_id, faculdade_id: this.props.faculdade.id });
            // $(this).val('');
            // $('#body_msg').append(template_send.replace(/%MSG%/g,msg).replace(/%ID%/g,uid_msg));
            // $('#body_msg').scrollTop($('#body_msg')[0].scrollHeight);
            let alunos = { ...this.state.alunos_m };
            // let aluno_select={...this.state.aluno_select};
            // aluno_select.mensagens.push({
            //     sender: { id: this.props.user.id, name: this.props.user.name, }, sender_id: this.props.user.id,
            //     receive_id: this.state.aluno_select.id, sala_id:this.state.aluno_select.sala_id, uuid: uid_msg, visto: false, message: msg
            // });
            alunos[this.state.alunoChat_select.id].mensagens.push({
                sender: { id: this.props.user.id, name: this.props.user.name, }, sender_id: this.props.user.id,
                receive_id: this.state.alunoChat_select.id, sala_id: this.state.alunoChat_select.sala_id, uuid: uid_msg, visto: undefined, message: msg,
                created_at: moment().format('YYYY-MM-DD HH:mm:ss')

            });
            this.setState({ alunos_m: alunos });
            return true;
        }
        return false;
    }



    get_messages_from_student(id) {
        console.log('id', id)
        console.log(this.state.alunos_m)
        return [...this.state.alunos_m[id].mensagens];
    }

    removeNotificacao(id_msg) {
        let mensagens_notificacao = {};
        delete (mensagens_notificacao[id_msg]);
        this.setState({ mensagens_notificacao });
    }

    removeNotificacaoValidacao(id_msg) {
        let validacao_notificacao = { ...this.state.validacao_notificacao };
        delete (validacao_notificacao[id_msg]);
        this.setState({ validacao_notificacao });
    }

    getRoomPendingValidationCount(salaId) {
        let count = 0;
        Object.values(this.state.alunos_m || {}).forEach((aluno) => {
            if (aluno?.sala_id == salaId && aluno?.request_validation != null && aluno.request_validation?.approved == null) {
                count++;
            }
        });
        return count;
    }

    getRoomPendingValidationTitle(count) {
        const t = languages[this.state.selectedLanguage] || languages.Pt;
        if (count == 1) {
            return t.pending_validation_room_single;
        }
        return t.pending_validation_room_multiple.replace('{count}', count);
    }

    renderRoomValidationBadge(salaId) {
        if (this.state.sala_select.id == salaId) {
            return null;
        }

        const count = this.getRoomPendingValidationCount(salaId);
        if (count <= 0) {
            return null;
        }

        return (
            <span className="fiscal-room-validation-badge" title={this.getRoomPendingValidationTitle(count)}>
                <i className="mdi mdi-face-recognition"></i>
                <small>{count}</small>
            </span>
        );
    }


    getExternalPeerId(alunoId) {
        return String(alunoId) + 'external_' + String(alunoId);
    }

    setGoodQualityStudent(alunoId, value) {
        this.good_quality_student[alunoId] = value;
        this.good_quality_student[this.getExternalPeerId(alunoId)] = value;
    }

    alter_video(aluno) {
        if (this.state.loading_alter_video[aluno.id] != true) {
            let loading_alter_video = { ...this.state.loading_alter_video }
            loading_alter_video[aluno.id] = true;
            this.setState({ loading_alter_video })
            this.socket.emit("alter_video", { aluno_id: aluno.id, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id });
            setTimeout(() => {
                let loading_alter_video = { ...this.state.loading_alter_video }
                loading_alter_video[aluno.id] = false;;
                this.setState({ loading_alter_video })
            }, 5000)
        }
    }

    good_quality_student_alter(aluno) {
        if (this.good_quality_student[aluno.id] != true && this.props.processo.good_quality == true) {
            this.setGoodQualityStudent(aluno.id, true);
            console.log(this.good_quality_student)
            this.socket.emit("good_quality", { good: true, aluno_id: aluno.id, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id });
        }
    }

    openCandidateChat(aluno) {
        if (this.state.loading_sala === true) {
            return;
        }
        this.sendReceive(aluno);
        this.props.mudarChatOpen(0);
        this.setState({ open_candidate_menu: null });
    }

    openCandidateRequests(aluno) {
        if (this.state.loading_sala === true) {
            return;
        }
        this.setState({ alunoChat_select: { ...this.state.alunos_m[aluno.id] }, open_candidate_menu: null });
        this.props.mudarChatOpen(1);
    }

    openCandidateFullscreen(aluno) {
        this.setState({ full_screen_open: true, aluno_fullscreen: aluno.id, alunoChat_select: { ...this.state.alunos_m[aluno.id] }, open_candidate_menu: null });
        this.fullscreen_ref.current.srcObject = aluno.videoRef.current.srcObject;
    }

    hasExternalCameraStream(aluno) {
        return !!(
            aluno != null &&
            aluno.stream_external != null &&
            this.state.candidate_screens[aluno.id]?.external_camera_connected == true
        );
    }

    setCandidateVideoView(aluno, view, fullscreen = false) {
        if (aluno == null || aluno.videoRef == null || aluno.videoRef.current == null) {
            return;
        }

        if (view == 'camera') {
            if (aluno.stream == null) {
                return;
            }
            aluno.videoRef.current.srcObject = aluno.stream;
            if (fullscreen == true && this.fullscreen_ref.current != null) {
                this.fullscreen_ref.current.srcObject = aluno.stream;
            }
            this.last_alter_external[aluno.id] = 'camera';
            this.setState({ open_candidate_menu: null });
            return;
        }

        if (view == 'screen') {
            if (this.props.processo.screen_sharing != true || aluno.stream == null) {
                return;
            }
            if (this.last_alter_external[aluno.id] == 'external') {
                aluno.videoRef.current.srcObject = aluno.stream;
                if (fullscreen == true && this.fullscreen_ref.current != null) {
                    this.fullscreen_ref.current.srcObject = aluno.stream;
                }
            }
            this.last_alter_external[aluno.id] = 'screen';
            this.alter_video(aluno);
            this.setState({ open_candidate_menu: null });
            return;
        }

        if (view == 'external') {
            if (!this.hasExternalCameraStream(aluno)) {
                return;
            }
            aluno.videoRef.current.srcObject = aluno.stream_external;
            if (fullscreen == true && this.fullscreen_ref.current != null) {
                this.fullscreen_ref.current.srcObject = aluno.stream_external;
            }
            this.last_alter_external[aluno.id] = 'external';
            this.setState({ open_candidate_menu: null });
        }
    }

    toggleExternalCamera(aluno) {
        this.setCandidateVideoView(aluno, 'external');
    }

    reconnectCandidate(aluno) {
        if (this.state.times_reconects[aluno.id] == null || moment().diff(this.state.times_reconects[aluno.id], 'seconds') > 60) {
            let times_reconects = { ...this.state.times_reconects };
            times_reconects[aluno.id] = moment();
            this.setState({ times_reconects, open_candidate_menu: null });
            this.socket.emit("reconect_user", { aluno_id: aluno.id, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id });
        }
        else {
            console.log(moment().diff(this.state.times_reconects[aluno.id], 'seconds'))
            this.setState({ open_candidate_menu: null });
        }
    }

    mergeCandidateScreensSnapshot(candidates, currentScreens = this.state.candidate_screens, replaceCurrentRoom = false) {
        if (candidates == null || typeof candidates !== 'object') {
            return replaceCurrentRoom ? {} : currentScreens;
        }

        let candidate_screens = replaceCurrentRoom ? {} : { ...currentScreens };
        Object.keys(candidates).forEach((alunoId) => {
            const candidate = candidates[alunoId];
            if (candidate != null && candidate.sala_id == this.state.sala_select.id) {
                candidate_screens[alunoId] = {
                    ...(candidate_screens[alunoId] || {}),
                    ...candidate
                };
            }
        });

        return candidate_screens;
    }

    isCandidateOnline(aluno) {
        return this.state.number_online.includes(aluno.id.toString());
    }

    getCandidateScreen(aluno) {
        return this.state.candidate_screens[aluno.id] || null;
    }

    getCandidateIp(aluno) {
        const candidateScreen = this.getCandidateScreen(aluno);
        return candidateScreen?.candidate_ip || candidateScreen?.ip || null;
    }

    candidateHasLiveStream(aluno) {
        return !!(aluno.videoRef && aluno.videoRef.current && aluno.videoRef.current.srcObject);
    }

    canShowLiveCandidateAlerts(aluno) {
        const screen = this.getCandidateScreen(aluno);
        return this.isCandidateOnline(aluno)
            && this.candidateHasLiveStream(aluno)
            && screen != null
            && screen.screen !== 'terms';
    }

    getCandidateAlerts(aluno) {
        const screen = this.getCandidateScreen(aluno);
        const t = languages[this.state.selectedLanguage] || languages.Pt;
        let alerts = [];
        if (!this.isCandidateOnline(aluno)) {
            return alerts;
        }
        if (this.props.processo.required_external_camera == true && screen != null && screen.external_camera_connected != true) {
            alerts.push(t.external_camera_missing);
        }
        if (this.props.processo.full_screen == true && screen?.candidate_inside_screen === false) {
            alerts.push(t.candidate_outside_screen);
        }
        return alerts;
    }

    toggleCandidateAlertDetails(aluno) {
        let candidate_alert_details_open = { ...this.state.candidate_alert_details_open };
        candidate_alert_details_open[aluno.id] = candidate_alert_details_open[aluno.id] != true;
        this.setState({ candidate_alert_details_open });
    }


    render() {
        console.log(this.good_quality_student)
        console.log(this.state.alunos_m)
        let t = languages[this.state.selectedLanguage] || languages.Pt;
        return (
            <div>
                {/* <HeaderSala showChatGeral={(e) => {
                    this.setState({ show_modal_chat_geral: e });
                }} /> */}

                {this.state.redirect == true && <Redirect to={this.state.path} />}

                {this.state.loading_screen == false && <div className="row fiscal-room-page">
                    {/* <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>{this.props.faculdade.name}</h4>
                                <p style={{ fontSize: '1rem', color: 'black' }}>Nome do Fiscal: {this.props.user.name}</p>

                                <h4 style={{ color: 'black' }}>Comunicado Geral</h4>


                                <div className="d-flex" style={{ marginBottom: '0.5rem', marginTop: '1rem' }}>
                                    <textarea id="msg_comunicado" placeholder="Escreva um comunicado Geral para enviar aos candidatos" className="form-control" style={{ resize: 'none', height: '100px' }} />
                                    <button className="btn btn-primary" id="enviar_comunicado">
                                        Enviar
                                        </button>
                                </div>

                            </div>
                        </div>
                    </div> */}
                    <div className="col-12">
                        <div className="card fiscal-room-shell" style={{ marginBottom: 0 }}>
                            <div className="card-body" style={{ padding: 0 }}>
                                <div className="row fiscal-room-toolbar">

                                    <div className="col-12 fiscal-room-head">
                                        <div>
                                            <nav className="fiscal-breadcrumb fiscal-room-breadcrumb" aria-label="breadcrumb">
                                                <Link to="/">{t.breadcrumb_home}</Link>
                                                <i className="mdi mdi-chevron-right"></i>
                                                <Link to="/">{t.breadcrumb_processes}</Link>
                                                <i className="mdi mdi-chevron-right"></i>
                                                <a>{t.title_rooms}</a>
                                            </nav>
                                            {(this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && <div className="fiscal-room-title-row">
                                                <h4>{t.title_rooms}</h4>
                                                <label className="fiscal-process-switcher">
                                                    <span>{t.process_label}</span>
                                                    <select value={this.state.current_processo_id} onChange={(e) => {
                                                        const processo = this.state.processos_salas.find((item) => item.id == e.target.value);
                                                        this.selectProcess(processo);
                                                    }}>
                                                        {this.state.processos_salas.map((processo) => (
                                                            <option key={processo.id} value={processo.id}>{processo.name}</option>
                                                        ))}
                                                    </select>
                                                </label>
                                            </div>}
                                            {(this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && <p>{this.props.processo.name}</p>}
                                        </div>
                                        <div className="fiscal-room-head-actions">
                                            <div className="fiscal-room-stats">
                                                <div className="fiscal-stat-card">
                                                    <span className="fiscal-stat-icon"><i className="mdi mdi-account-multiple-outline"></i></span>
                                                    <div>
                                                        <p>{t.total_online}</p>
                                                        <strong id="online_number">{this.state.number_online.length}</strong>
                                                    </div>
                                                </div>
                                                <div className="fiscal-stat-card">
                                                    <span className="fiscal-stat-icon"><i className="mdi mdi-clipboard-account-outline"></i></span>
                                                    <div>
                                                        <p>{t.online_this_room}</p>
                                                        <strong id="online_number">{Object.keys(this.state.sala_select.alunos).filter((item, id) => this.state.number_online.includes(item)).length}</strong>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 fiscal-room-actions-row">
                                        <div className="fiscal-room-actions">
                                            <button title={t.candidate_list} onClick={() => {
                                                if (this.state.loading_sala) return;
                                                this.setState({ list_open: !this.state.list_open })
                                            }} className="btn fiscal-action-btn fiscal-action-cyan" ><i className="mdi mdi-format-list-bulleted"></i><span>{t.candidates}</span></button>

                                            <button title={!this.state.show_notification ? t.show_notifications : t.hide_notifications} onClick={() => {
                                                this.setState({ show_notification:!this.state.show_notification });
                                            }} className='btn fiscal-action-btn fiscal-action-orange'><i className={this.state.show_notification ? 'mdi mdi-bell-ring-outline' : 'mdi mdi-bell-off-outline'}></i><span>{t.notifications}</span></button>

                                            <button title={!this.state.show_disconnected ? t.only_disconnected : t.show_all} onClick={() => {
                                                this.setState({ show_disconnected:!this.state.show_disconnected });
                                            }} className='btn fiscal-action-btn fiscal-action-cyan'><i className='mdi mdi-monitor'></i><span>{this.state.show_disconnected ? t.show_all : t.only_disconnected}</span></button>

                                            {(this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && this.props.processo.chat_type != 'none' && <button title={t.room_message} onClick={() => {
                                                if (this.state.loading_sala) return;

                                                this.setState({ alunoChat_select: { id: 'comunicado', name: 'Mensagem para Sala ' + this.state.sala_select.numero, sala_id: this.state.sala_select.id, numero: this.state.sala_select.numero } });
                                                this.props.mudarChatOpen(0);
                                            }} className="btn fiscal-message-btn fiscal-message-primary" ><i className="mdi mdi-send"></i><span>{t.room}</span></button>}
                                            {this.props.user.role == 'fiscal_coordenador' && (this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && this.props.processo.chat_type != 'none' && <button title={t.general_announcement} onClick={() => {
                                                this.setState({ alunoChat_select: { id: 'comunicado', name: 'Comunicado Geral' } });
                                                this.props.mudarChatOpen(0);
                                            }} className="btn fiscal-message-btn fiscal-message-info" ><i className="mdi mdi-bullhorn-outline"></i><span>{t.general}</span></button>}

                                            {(this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && this.props.processo.chat_type != 'none' && <button title={t.chat} onClick={() => {
                                                this.setState({ show_modal_chat_geral: true });
                                            }} className="btn fiscal-message-btn fiscal-message-outline" ><i className="mdi mdi-chat-outline"></i><span>{t.chat}</span></button>}

                                            <Link onClick={() => {
                                                let keys = Object.keys(this.list_peers);
                                                for (let i = 0; i < keys.length; i++) {
                                                    this.list_peers[keys[i]].close();
                                                }
                                                for (let i = 0; i < Object.keys(this.state.sala_select.alunos).length; i++) {
                                                    if (this.state.sala_select.alunos[Object.keys(this.state.sala_select.alunos)[i]].videoRef.current != null) {
                                                        this.state.sala_select.alunos[Object.keys(this.state.sala_select.alunos)[i]].desconectado = true;
                                                        this.state.sala_select.alunos[Object.keys(this.state.sala_select.alunos)[i]].videoRef.current.srcObject = null;
                                                    }
                                                }
                                            }} to='/' className="btn fiscal-back-btn" ><i className="mdi mdi-arrow-left"></i><span>{t.back}</span></Link>
                                        </div>
                                    </div>

                                    {this.state.processos_salas.length > 1 && <div className="col-12 fiscal-process-room-selector">
                                        <div className="fiscal-process-chip-list">
                                            {this.state.processos_salas.map((processo) => (
                                                <button
                                                    key={processo.id}
                                                    type="button"
                                                    className={processo.id == this.state.current_processo_id ? 'fiscal-process-chip active' : 'fiscal-process-chip'}
                                                    onClick={() => this.selectProcess(processo)}>
                                                    <i className="mdi mdi-clipboard-text-outline"></i>
                                                    <span>
                                                        <strong>{processo.name}</strong>
                                                        <small>{processo.salas_count} {t.rooms_short} • {processo.candidatos_count} {t.candidates_short}</small>
                                                    </span>
                                                </button>
                                            ))}
                                        </div>
                                        <label className="fiscal-all-process-toggle">
                                            <input type="checkbox" checked={this.state.show_all_process_rooms} onChange={(e) => this.toggleAllProcessRooms(e.target.checked)} />
                                            <span>{t.view_all_process_rooms}</span>
                                        </label>
                                    </div>}

                                        {this.props.processo.interview == true && <div className="col-12" style={{ border: '1px dashed #17a2b8', width: '100%', padding: 5 }}>
                                            <p style={{ color: '#17a2b8', fontSize: 18, textAlign: 'center', marginBottom: 5 }}>{t.candidates_in_queue}: <span id="online_number"><b>{this.state.number_line?.length}</b></span>  </p>
                                            {this.state.number_line?.length > 0 && <div className='d-flex justify-content-center align-items-center'>
                                                <button onClick={() => {
                                                    this.props.history.push({ pathname: '/presentation/' + this.props.processo.id, search: '?sala_id=' + this.state.sala_select.id })
                                                }} className='btn btn-info'>Falar com o(s) candidato(s) <i className='mdi mdi-call-made'></i></button>
                                            </div>}

                                        </div>}


                                    {this.state.show_all_process_rooms == true && <div className="col-12 fiscal-all-process-rooms">
                                        {this.state.processos_salas.map((processo) => (
                                            <div key={processo.id} className="fiscal-all-process-group">
                                                <strong>{processo.name}</strong>
                                                <div>
                                                    {processo.salas.map((sala) => (
                                                        <button
                                                            key={sala.id}
                                                            type="button"
                                                            className={sala.id == this.state.sala_select.id ? 'active' : ''}
                                                            onClick={() => this.selectProcess(processo, sala)}>
                                                            {t.room} {sala.numero}
                                                            <small>{sala.candidatos_count} {t.candidates_short}</small>
                                                            {this.renderRoomValidationBadge(sala.id)}
                                                        </button>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>}

                                    {this.state.show_all_process_rooms == false && this.state.salas.map((item, id) => (

                                        <div key={id} className="col-3 fiscal-room-tab-wrap">


                                            <a onClick={() => {
                                                this.selectRoom(item);
                                            }} className={this.state.sala_select.id == item.id ? 'fiscal-room-tab active' : 'fiscal-room-tab'}>
                                                <span>{t.room} {item.numero}</span>
                                                <strong>{Object.keys(item.alunos).filter((aluno_id) => this.state.number_online.includes(aluno_id)).length}</strong>
                                                {this.renderRoomValidationBadge(item.id)}
                                                <div >
                                                    {/* <div className="msg_count" style="position: absolute;right:20px;top:10px">
                                        <span>Nova</span>
                                    </div> */}
                                                </div>


                                            </a>

                                        </div>
                                    ))}
                                </div>
                                <hr />

                                {this.state.loading_sala == true && <Loader compact title={t.loading} description={null} />}





                                {this.state.loading_sala == false && (this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && <div className="row fiscal-candidate-grid" style={{ marginRight: this.props.chat_open != -1 || this.state.list_open ? 380 : 0 }}>
                                    {Object.values(this.state.sala_select.alunos).map((aluno, id) => (
                                        this.state.alunos_m[aluno.id] != undefined && <div key={id}
                                            // onClick={() => {
                                                hidden={this.state.show_disconnected==true && this.state.number_online.includes(aluno.id.toString())}

                                            //     this.setState({ full_screen_open: true, aluno_fullscreen: id });
                                            //     this.fullscreen_ref.current.srcObject = aluno.videoRef.current.srcObject;
                                            // }}
                                            className={'fiscal-candidate-card ' + (this.state.open_candidate_menu == aluno.id ? 'menu-open ' : '') + ((this.canShowLiveCandidateAlerts(aluno) && this.state.alunos_m[aluno.id].request_validation != null && this.state.alunos_m[aluno.id].request_validation?.approved == null) ? 'blink_face' : ((this.canShowLiveCandidateAlerts(aluno) && this.state.video_blink[aluno.id] == true) || this.getCandidateAlerts(aluno).length > 0 ? 'blink' : ''))}
                                            style={{ position: 'relative', padding: 0, flex: "1 0 16.666%", maxWidth: this.state.width_candidato_box, height: this.state.height_candidato_box, display: 'flex', justifyContent: 'center', marginTop: '0rem' }}>
                                            <div className={"coluna_video"}
                                                style={{ width: '100%', height: '100%', background: 'black' }}>
                                                {!this.state.number_online.includes(aluno.id.toString()) && <div className="fiscal-candidate-offline desconectado{{$aluno->id}}"
                                                    style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute' }}>
                                                    <i className="mdi mdi-video-off-outline"></i>
                                                </div>}
                                                {this.state.number_online.includes(aluno.id.toString()) && this.state.candidate_screens[aluno.id]?.screen == 'terms' && this.state.candidate_screens[aluno.id]?.has_stream == false && <div className="fiscal-candidate-stage-placeholder">
                                                    <i className="mdi mdi-file-document-check-outline"></i>
                                                    <strong>{t.stage_terms}</strong>
                                                    <span>{t.stage_terms_waiting}</span>
                                                </div>}
                                                <div style={{ height: '100%', display: 'flex' }} className="align-items-center">
                                                    <video id={aluno.id} ref={aluno.videoRef} className="video_tag_aluno" autoPlay muted style={{ zIndex: !this.state.number_online.includes(aluno.id.toString()) ? -1 : 'inherit', width: '100%', height: '100%', objectFit: 'contain', position: 'absolute', background: 'black' }} ></video>
                                                </div>
                                                {this.canShowLiveCandidateAlerts(aluno) && this.state.video_blink_movement[aluno.id] == true && <div className="blink_background" style={{ position: 'absolute', bottom: 30, left: 10 }}>
                                                    <p style={{ marginBottom: 0, fontSize: 10, color: 'white', marginLeft: 4, marginRight: 4 }}>Múltipas faces</p>
                                                </div>}
                                                {this.state.alunos_m[aluno.id].requests.filter((item) => item.started != null && item.pause_end == null).length > 0 && <div className="blink_pause" style={{ position: 'absolute', bottom: 30, right: 10 }}>
                                                    <p style={{ marginBottom: 0, fontSize: 10, color: 'white', marginLeft: 4, marginRight: 4 }}>{moment().diff(moment(this.state.alunos_m[aluno.id].requests.filter((item) => item.started != null && item.pause_end == null)[0].started).add('seconds', this.state.alunos_m[aluno.id].requests.filter((item) => item.started != null && item.pause_end == null)[0].time), 'seconds') > 0 ? 'Atraso para voltar' : 'Em Pausa'}</p>
                                                </div>}
                                                <div
                                                    style={{ position: 'absolute', top: '10px', right: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 11 }}>
                                                    <div hidden className={"bar1" + aluno.id} ref={aluno.bar1} id="bar1_principal"
                                                        style={{ width: '4px', height: '0px', borderRadius: '100px', border: '0.5px solid black', backgroundColor: 'yellow', marginRight: '1px' }}>
                                                    </div>
                                                    <div hidden className={"bar2" + aluno.id} ref={aluno.bar2} id="bar2_principal"
                                                        style={{ width: '4px', height: '0px', borderRadius: '100px', border: '0.5px solid black', backgroundColor: 'yellow', marginRight: '1px' }}>
                                                    </div>
                                                    <div hidden className={"bar3" + aluno.id} ref={aluno.bar3} id="bar3_principal"
                                                        style={{ width: '4px', height: '0px', borderRadius: '100px', border: '0.5px solid black', backgroundColor: 'yellow', marginRight: '1px' }}>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="fiscal-candidate-name">
                                                <p>{aluno.name}</p>
                                                <span>#{aluno?.numero_inscricao || aluno.id}</span>
                                            </div>
                                            <div className={this.state.number_online.includes(aluno.id.toString()) ? 'fiscal-candidate-status online' : 'fiscal-candidate-status offline'}>
                                                <span></span>{this.state.number_online.includes(aluno.id.toString()) ? t.online : t.offline}
                                            </div>
                                            {this.state.number_online.includes(aluno.id.toString()) && this.state.candidate_screens[aluno.id] != null && <div className={`fiscal-candidate-stage stage-${this.state.candidate_screens[aluno.id].screen}`}>
                                                <i className={this.state.candidate_screens[aluno.id].screen == 'evaluation' ? 'mdi mdi-pencil-outline' : this.state.candidate_screens[aluno.id].screen == 'rules' ? 'mdi mdi-shield-check-outline' : this.state.candidate_screens[aluno.id].screen == 'waiting' ? 'mdi mdi-clock-outline' : this.state.candidate_screens[aluno.id].screen == 'finished' ? 'mdi mdi-check-circle-outline' : this.state.candidate_screens[aluno.id].screen == 'face_validation' ? 'mdi mdi-face-recognition' : (this.state.candidate_screens[aluno.id].screen == 'document_validation' || this.state.candidate_screens[aluno.id].screen == 'identity_validation') ? 'mdi mdi-account-card-details' : 'mdi mdi-file-document-outline'}></i>
                                                {t[`stage_${this.state.candidate_screens[aluno.id].screen}`] || t.stage_terms}
                                            </div>}
                                            {this.getCandidateAlerts(aluno).length > 0 && <button
                                                type="button"
                                                title={this.state.candidate_alert_details_open[aluno.id] == true ? t.hide_alerts : t.show_alerts}
                                                className="fiscal-candidate-alert-info"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.toggleCandidateAlertDetails(aluno);
                                                }}>
                                                <i className="mdi mdi-information-outline"></i>
                                            </button>}
                                            {this.state.candidate_alert_details_open[aluno.id] == true && this.getCandidateAlerts(aluno).length > 0 && <div className="fiscal-candidate-alert-menu">
                                                {this.getCandidateAlerts(aluno).map((alert, idAlert) => (
                                                    <p key={idAlert}>{alert}</p>
                                                ))}
                                            </div>}
                                            {this.state.alunos_m[aluno.id].mensagens.filter((item, id) => item.warning == true && item.message == 'O candidato saiu da página da avaliação').length > 0 && <span
                                                title={t.screen_exits}
                                                className="fiscal-candidate-exit-badge">
                                                <i className="mdi mdi-alert-outline"></i>
                                                {this.state.alunos_m[aluno.id].mensagens.filter((item, id) => item.warning == true && item.message == 'O candidato saiu da página da avaliação').length}
                                            </span>}
                                            <div className="fiscal-candidate-quick-actions">
                                                {this.props.processo.chat_type != 'none' && this.state.alunos_m[aluno.id]?.counter > 0 && <button type="button" title={t.unread_messages} onClick={() => this.openCandidateChat(aluno)}>
                                                    <i className="mdi mdi-chat-outline"></i>
                                                    <strong>{this.state.alunos_m[aluno.id].counter}</strong>
                                                </button>}
                                                {this.props.processo.chat_type != 'none' && this.state.alunos_m[aluno.id] != undefined && (this.state.alunos_m[aluno.id].requests.length > 0 && this.state.alunos_m[aluno.id].requests[this.state.alunos_m[aluno.id].requests.length - 1].approved == null) && <button type="button" title={t.pending_request} onClick={() => this.openCandidateRequests(aluno)}>
                                                    <i className="mdi mdi-pause-circle-outline"></i>
                                                    <strong>1</strong>
                                                </button>}
                                                {this.canShowLiveCandidateAlerts(aluno) && this.state.alunos_m[aluno.id].request_validation != null && this.state.alunos_m[aluno.id].request_validation?.approved == null && <button type="button" className="attention" title={t.release_request} onClick={() => this.setState({ open_validation_modal: true, validation_student_id: aluno.id, open_candidate_menu: null })}>
                                                    <i className="mdi mdi-face-recognition"></i>
                                                </button>}
                                            </div>
                                            <div className="fiscal-candidate-controls">
                                                <button
                                                    type="button"
                                                    onClick={() => this.openCandidateFullscreen(aluno)}
                                                    title={t.fullscreen}
                                                    className="fiscal-candidate-control">
                                                    <i className="mdi mdi-fullscreen"></i>
                                                </button>
                                                <button
                                                    type="button"
                                                    title={t.options}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        this.setState({ open_candidate_menu: this.state.open_candidate_menu == aluno.id ? null : aluno.id });
                                                    }}
                                                    className="fiscal-candidate-control fiscal-candidate-menu-toggle">
                                                    <i className="mdi mdi-dots-vertical"></i>
                                                </button>
                                            </div>
                                            {this.state.open_candidate_menu == aluno.id && <div className="fiscal-candidate-menu" onClick={(e) => e.stopPropagation()}>
                                                {this.isCandidateOnline(aluno) && this.getCandidateIp(aluno) != null && <div className="fiscal-candidate-ip-info">
                                                    <i className="mdi mdi-ip-network-outline"></i>
                                                    <span>{t.candidate_ip}</span>
                                                    <strong>{this.getCandidateIp(aluno)}</strong>
                                                </div>}
                                                {this.props.processo.chat_type != 'none' && <button type="button" onClick={() => this.openCandidateChat(aluno)}><i className="mdi mdi-chat-outline"></i> {t.open_chat} {this.state.alunos_m[aluno.id]?.counter > 0 && <strong>{this.state.alunos_m[aluno.id].counter}</strong>}</button>}
                                                {this.props.processo.chat_type != 'none' && <button type="button" onClick={() => this.openCandidateRequests(aluno)}><i className="mdi mdi-pause-circle-outline"></i> {t.requests} {this.state.alunos_m[aluno.id] != undefined && (this.state.alunos_m[aluno.id].requests.length > 0 && this.state.alunos_m[aluno.id].requests[this.state.alunos_m[aluno.id].requests.length - 1].approved == null) && <strong>1</strong>}</button>}
                                                <button type="button" onClick={() => this.openCandidateFullscreen(aluno)}><i className="mdi mdi-fullscreen"></i> {t.fullscreen}</button>
                                                <button type="button" onClick={() => this.setCandidateVideoView(aluno, 'camera')}><i className="mdi mdi-video-outline"></i> {t.view_camera}</button>
                                                {this.props.processo.screen_sharing == true && <button type="button" onClick={() => this.setCandidateVideoView(aluno, 'screen')}><i className="mdi mdi-monitor-multiple"></i> {t.view_screen}</button>}
                                                <button type="button" onClick={() => this.setCandidateVideoView(aluno, 'external')}><i className="mdi mdi-cellphone"></i> {t.view_external_camera}</button>
                                                <button type="button" onClick={() => { this.setState({ candidato_selectAcao: aluno, show_modal_action: true, open_candidate_menu: null }); }}><i className="fas fa-exclamation-circle"></i> {t.report_action}</button>
                                                <button type="button"><i className="mdi mdi-alert-outline"></i> {t.left_exam} <strong>{this.state.alunos_m[aluno.id].mensagens.filter((item, id) => item.warning == true && item.message == 'O candidato saiu da página da avaliação').length}</strong></button>
                                                <button type="button" onClick={() => this.reconnectCandidate(aluno)}><i className="mdi mdi-reload"></i> {t.reconnect}</button>
                                                {this.state.alunos_m[aluno.id].presence != null && <button type="button" onClick={() => { this.setState({ list_open: !this.state.list_open, open_candidate_menu: null }) }}><i className={this.state.alunos_m[aluno.id].presence.presence ? "mdi mdi-check" : "mdi mdi-close"}></i> {this.state.alunos_m[aluno.id].presence.presence ? t.present : t.absent}</button>}
                                                {this.canShowLiveCandidateAlerts(aluno) && this.state.alunos_m[aluno.id].request_validation != null && this.state.alunos_m[aluno.id].request_validation?.approved == null && <button type="button" className="attention" onClick={() => this.setState({ open_validation_modal: true, validation_student_id: aluno.id, open_candidate_menu: null })}><i className="mdi mdi-face"></i> {t.release_request}</button>}
                                            </div>}
                                        </div>
                                    ))}
                                </div>}
                                <div hidden={!this.state.full_screen_open}
                                    className="fiscal-fullscreen-overlay"
                                    style={{ padding: 0, position: 'fixed', top: 0, bottom: 0, left: 0, right: this.props.chat_open != -1 || this.state.list_open ? 300 : 0, zIndex: 1000 }}>
                                    <div className="coluna_video fiscal-fullscreen-stage"
                                        style={{ width: '100%', height: '100%', background: 'black' }}>
                                        <div onClick={() => {
                                            console.log('good quality', this.good_quality_student[this.state.alunoChat_select.id])
                                            if (this.good_quality_student[this.state.alunoChat_select.id] && this.props.processo.good_quality == true) {
                                                this.setGoodQualityStudent(this.state.alunoChat_select.id, false);
                                                this.socket.emit("good_quality", { good: false, aluno_id: this.state.alunoChat_select.id, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id });
                                            }
                                            this.fullscreen_ref.current.srcObject = null;
                                            this.setState({ aluno_fullscreen: -1, full_screen_open: false });

                                        }} className="fiscal-fullscreen-close close"><i className="mdi mdi-close"></i></div>
                                        {this.state.alunoChat_select.id != undefined && !this.state.number_online.includes(this.state.alunoChat_select.id.toString()) && this.state.aluno_fullscreen != -1 && <div className="desconectado{{$aluno->id}}"
                                            style={{ height: '100%', width: '100%', backgroundColor: 'rgba(0,0,0,1)', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute' }}>
                                            <p style={{ color: 'white', fontSize: '1rem', zIndex: 1 }}>Desconectado...</p>
                                        </div>}
                                        <video ref={this.fullscreen_ref} className="video_tag_aluno fiscal-fullscreen-video" autoPlay style={{ height: '100%', width: '100%', position: 'absolute' }} ></video>
                                        {this.state.alunoChat_select.id != undefined && this.state.aluno_fullscreen != -1 && <p className="fiscal-fullscreen-presence" onClick={(e) => {
                                            this.setState({ list_open: !this.state.list_open });
                                        }} style={{ cursor: 'pointer', marginBottom: 0, color: 'black', fontSize: 15, position: 'absolute', top: 10, background: 'white', borderRadius: 10, padding: 2 }}><b>Presença:</b> {this.state.alunos_m[this.state.alunoChat_select.id].presence == null ? (<span style={{ color: 'darkgoldenrod' }}>Não registrado</span>) : (this.state.alunos_m[this.state.alunoChat_select.id].presence.presence ? <span style={{ color: 'green' }}>Presente</span> : <span style={{ color: 'red' }}>Ausente</span>)} <i className='mdi mdi-arrow-right'></i></p>}
                                    </div>
                                    {/* <div onClick={() => {
                                        if (this.state.aluno_fullscreen == 0) {
                                            let indice = Object.values(this.state.sala_select.alunos).length - 1;
                                            this.setState({ aluno_fullscreen: indice, alunoChat_select: { ...this.state.alunos_m[Object.values(this.state.sala_select.alunos)[indice].id] } });
                                            this.fullscreen_ref.current.srcObject = Object.values(this.state.sala_select.alunos)[indice].videoRef.current.srcObject;
                                        }
                                        else {
                                            let indice = this.state.aluno_fullscreen - 1;
                                            this.setState({ aluno_fullscreen: indice, alunoChat_select: { ...this.state.alunos_m[Object.values(this.state.sala_select.alunos)[indice].id] } });
                                            this.fullscreen_ref.current.srcObject = Object.values(this.state.sala_select.alunos)[indice].videoRef.current.srcObject;
                                        }
                                    }} style={{ position: 'absolute', top: '50%', left: '10px', color: 'white', zIndex: 5000 }} className="close"><i className="mdi mdi-arrow-left-thick" style={{ fontSize: '1.7rem' }}></i></div>

                                    <div onClick={() => {
                                        if (this.state.aluno_fullscreen == Object.values(this.state.sala_select.alunos).length - 1) {
                                            let indice = 0;
                                            this.setState({ aluno_fullscreen: indice, alunoChat_select: { ...this.state.alunos_m[Object.values(this.state.sala_select.alunos)[indice].id] } });
                                            this.fullscreen_ref.current.srcObject = Object.values(this.state.sala_select.alunos)[indice].videoRef.current.srcObject;
                                        }
                                        else {
                                            let indice = this.state.aluno_fullscreen + 1;
                                            this.setState({ aluno_fullscreen: indice, alunoChat_select: { ...this.state.alunos_m[Object.values(this.state.sala_select.alunos)[indice].id] } });
                                            this.fullscreen_ref.current.srcObject = Object.values(this.state.sala_select.alunos)[indice].videoRef.current.srcObject;
                                        }
                                    }} style={{ position: 'absolute', top: '50%', right: '10px', color: 'white', zIndex: 5000 }} className="close"><i className="mdi mdi-arrow-right-thick" style={{ fontSize: '1.7rem' }}></i></div> */}

                                    {/* <div style={{ position: 'absolute', color: 'white', background: 'black', right: 0, left: 0, bottom: 0 }}>
                                        {this.state.aluno_fullscreen != -1 && <p style={{ textAlign: 'center', margin: 0 }}>({this.state.aluno_fullscreen + 1}/{Object.keys(this.state.sala_select.alunos).length}) - {Object.values(this.state.sala_select.alunos)[this.state.aluno_fullscreen].name}</p>}
                                    </div> */}
                                    {this.state.alunoChat_select.mensagens != undefined && <div className="fiscal-fullscreen-info" style={{ position: 'absolute', color: 'white', boxShadow: '0px 1px 3px 0px rgb(60 64 67 / 30%), 0px 4px 8px 3px rgb(60 64 67 / 15%)', borderRadius: 8, background: 'rgba(0,0,0,0.5)', right: 0, left: 0, bottom: 0, height: 'auto', padding: 5 }}>
                                        <p style={{ margin: 0 }}>{this.state.alunoChat_select.name}</p>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>

                                                {this.props.processo.chat_type != 'none' && <div data-tip={"Abrir o chat com o candidato " + this.state.alunoChat_select.name + ""} className="icon_box" style={{ position: 'relative', marginRight: 2 }} onClick={(e) => {
                                                    // e.stopPropagation();
                                                    let aluno2 = this.state.alunos_m[this.state.alunoChat_select.id];
                                                    this.sendReceive(aluno2);

                                                    this.props.mudarChatOpen(0);
                                                }}>
                                                    <ReactTooltip />

                                                    <i style={{ color: 'inherit' }} className="mdi mdi-chat"></i>
                                                    {this.state.alunos_m[this.state.alunoChat_select.id] != undefined && this.state.alunos_m[this.state.alunoChat_select.id].counter > 0 && <div style={{
                                                        // padding: '2px',
                                                        // paddingTop: '3px',
                                                        // height:15,
                                                        minWidth: 20,
                                                        background: 'rgb(75, 181, 67)',
                                                        borderRadius: '50px',
                                                        position: 'absolute',
                                                        top: -5,
                                                        textAlign: 'center',
                                                        // paddingBottom: '3px',
                                                        right: -5
                                                    }}>

                                                        <span style={{ color: 'white', textAlign: 'center', fontSize: 11 }}>{this.state.alunos_m[this.state.alunoChat_select.id].counter}</span>
                                                    </div>}
                                                </div>}

                                                {this.props.processo.chat_type != 'none' && <div data-tip={"Visualizar solicitações do candidato " + this.state.alunos_m[this.state.alunoChat_select.id].name + ""} className="icon_box" style={{ position: 'relative', marginRight: 2 }} onClick={(e) => {
                                                    // e.stopPropagation();
                                                    if (this.state.loading_sala === true) {
                                                        return;
                                                    }
                                                    let aluno2 = this.state.alunos_m[this.state.alunoChat_select.id];
                                                    this.setState({ alunoChat_select: { ...aluno2 } });

                                                    this.props.mudarChatOpen(1);
                                                }}>
                                                    <ReactTooltip />

                                                    <i style={{ color: 'inherit' }} className="mdi mdi-pause-circle"></i>
                                                    {this.state.alunos_m[this.state.alunoChat_select.id] != undefined && (this.state.alunos_m[this.state.alunoChat_select.id].requests.length > 0 &&
                                                        this.state.alunos_m[this.state.alunoChat_select.id].requests[this.state.alunos_m[this.state.alunoChat_select.id].requests.length - 1].approved == null
                                                    ) && <div style={{
                                                        // padding: '2px',
                                                        // paddingTop: '3px',
                                                        // height:15,
                                                        minWidth: 20,
                                                        background: '#17a2b8',
                                                        borderRadius: '50px',
                                                        position: 'absolute',
                                                        top: -5,
                                                        textAlign: 'center',
                                                        // paddingBottom: '3px',
                                                        right: -5
                                                    }}>

                                                            <span style={{ color: 'white', textAlign: 'center', fontSize: 11 }}>1</span>
                                                        </div>}
                                                </div>}

                                                <div data-tip={"Número de vezes que o candidato " + this.state.alunoChat_select.name + " saiu da tela"} className="icon_box" style={{ position: 'relative', marginRight: 2 }} >
                                                    <ReactTooltip />
                                                    <span style={{ color: this.state.alunos_m[this.state.alunoChat_select.id].mensagens.filter((item, id) => item.warning == true && item.message == 'O candidato saiu da página da avaliação').length > 0 ? 'yellow' : 'white', textAlign: 'center', fontSize: 11 }}>{this.state.alunos_m[this.state.alunoChat_select.id].mensagens.filter((item, id) => item.warning == true && item.message == 'O candidato saiu da página da avaliação').length}</span>

                                                </div>
                                                <div
                                                    onClick={() => {
                                                        const aluno = this.state.sala_select.alunos[this.state.alunoChat_select.id];
                                                        this.setCandidateVideoView(aluno, 'camera', true);
                                                    }}
                                                    data-tip={t.view_camera} className="icon_box" style={{ position: 'relative', marginRight: 2 }} >
                                                    <ReactTooltip />
                                                    <i style={{ color: 'inherit' }} className="mdi mdi-video-outline"></i>
                                                </div>

                                                {this.props.processo.screen_sharing == true && <div
                                                    onClick={() => {
                                                        const aluno = this.state.sala_select.alunos[this.state.alunoChat_select.id];
                                                        this.setCandidateVideoView(aluno, 'screen', true);
                                                    }}
                                                    data-tip={t.view_screen} className="icon_box" style={{ position: 'relative', marginRight: 2 }} >
                                                    <ReactTooltip />
                                                    {this.state.loading_alter_video[this.state.alunoChat_select.id] != true && <i style={{ color: 'inherit' }} className="mdi mdi-monitor-multiple"></i>}
                                                    {this.state.loading_alter_video[this.state.alunoChat_select.id] == true && <i className="mdi mdi-loading fiscal-inline-loading"></i>}
                                                </div>}

                                                <div
                                                    onClick={() => {
                                                        const aluno = this.state.sala_select.alunos[this.state.alunoChat_select.id];
                                                        this.setCandidateVideoView(aluno, 'external', true);
                                                    }}
                                                    data-tip={t.view_external_camera} className="icon_box" style={{ position: 'relative', marginRight: 2 }} >
                                                    <ReactTooltip />
                                                    <i style={{ color: 'inherit' }} className="mdi mdi-cellphone"></i>
                                                </div>

                                                <div
                                                    onClick={() => {
                                                        this.setState({ candidato_selectAcao: this.state.alunoChat_select, show_modal_action: true });
                                                        // this.setState({ full_screen_open: true, aluno_fullscreen: id, alunoChat_select: { ...this.state.alunos_m[aluno.id] } });
                                                        // this.fullscreen_ref.current.srcObject = aluno.videoRef.current.srcObject;
                                                    }}
                                                    data-tip={t.report_candidate_action} className="icon_box" style={{ position: 'relative', marginRight: 2 }} >
                                                    <ReactTooltip />
                                                    <i style={{ color: 'inherit' }} className="fas fa-exclamation-circle"></i>

                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: 2 }}>
                                                    {this.state.alunos_m[this.state.alunoChat_select.id].finish == 'F' && <div data-tip={"Candidato finalizou a avaliação"} style={{ borderRadius: 100, backgroundColor: '#815ae4', height: 25, display: 'flex', justifyContent: 'center', alignItems: 'center', width: 30, height: 30 }}>
                                                        <p style={{ margin: 0, color: 'white', fontSize: 10 }}>F</p>
                                                        <ReactTooltip />
                                                    </div>}
                                                    {this.state.alunos_m[this.state.alunoChat_select.id].finish == 'I' && <div data-tip={"Candidato não finalizou a avaliação"} style={{ borderRadius: 100, backgroundColor: 'darkgoldenrod', height: 25, display: 'flex', justifyContent: 'center', alignItems: 'center', width: 30, height: 30 }}>
                                                        <p style={{ margin: 0, color: 'white', fontSize: 10 }}>NF</p>
                                                        <ReactTooltip />
                                                    </div>}
                                                </div>
                                                {this.props.processo.good_quality && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <div onClick={() => {
                                                        this.good_quality_student_alter(this.state.alunoChat_select)
                                                    }} data-tip={"Video em boa qualidade"} className="icon_box" style={{ position: 'relative' }}>
                                                        <i style={{ color: 'inherit' }} className="mdi mdi-high-definition"></i>
                                                        <ReactTooltip />
                                                    </div>
                                                </div>}



                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <div onClick={() => {
                                                        if (this.state.times_reconects[this.state.alunoChat_select.id] == null) {
                                                            let times_reconects = { ...this.state.times_reconects };

                                                            times_reconects[this.state.alunoChat_select.id] = moment();
                                                            this.setState({ times_reconects });
                                                            console.log('Reconectando');
                                                            this.socket.emit("reconect_user", { aluno_id: this.state.alunoChat_select.id, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id });

                                                        }
                                                        else {
                                                            if (moment().diff(this.state.times_reconects[this.state.alunoChat_select.id], 'seconds') > 60) {
                                                                let times_reconects = { ...this.state.times_reconects };

                                                                times_reconects[this.state.alunoChat_select.id] = moment();
                                                                this.setState({ times_reconects });
                                                                this.socket.emit("reconect_user", { aluno_id: this.state.alunoChat_select.id, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id });
                                                            }
                                                            else {
                                                                console.log(moment().diff(this.state.times_reconects[this.state.alunoChat_select.id], 'seconds'))
                                                            }

                                                        }
                                                    }} data-tip={"Reconectar com o candidato"} className="icon_box" style={{ position: 'relative' }}>
                                                        <i style={{ color: 'inherit' }} className="mdi mdi-reload"></i>
                                                        <ReactTooltip />
                                                    </div>
                                                </div>
                                                {this.state.alunos_m[this.state.alunoChat_select?.id]?.presence != null && <div
                                                    onClick={() => {
                                                        this.setState({ list_open: !this.state.list_open })
                                                    }}
                                                    data-tip={this.state.alunos_m[this.state.alunoChat_select.id].presence.presence ? "Candidato marcado como presente" : "Candidato marcado como ausente"} className="icon_box" style={{ position: 'relative', marginRight: 2, background: this.state.alunos_m[this.state.alunoChat_select.id].presence.presence ? 'green' : 'red' }} >
                                                    <ReactTooltip />
                                                    <i style={{ color: 'inherit' }} className={this.state.alunos_m[this.state.alunoChat_select?.id].presence.presence ? "mdi mdi-check" : "mdi mdi-close"}></i>

                                                </div>}
                                                {this.state.alunos_m[this.state.alunoChat_select?.id]?.request_validation != null && this.state.alunos_m[this.state.alunoChat_select?.id]?.request_validation?.approved == null && <div
                                                    onClick={() => {
                                                        // this.setState({list_open:!this.state.list_open})
                                                        this.setState({ open_validation_modal: true, validation_student_id: this.state.alunoChat_select?.id });
                                                    }}
                                                    data-tip={"Candidato pediu liberação para o fiscal"} className="icon_box blink_face" style={{ position: 'relative', marginRight: 2 }} >
                                                    <ReactTooltip />
                                                    <i style={{ color: 'inherit' }} className={"mdi mdi-face"}></i>

                                                </div>}
                                            </div>
                                            {this.state.alunoChat_select?.accessibility == true && this.state.alunoChat_select?.type_supervisor != 'none' && <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>

                                                {this.props.socket != null && <button onClick={() => {
                                                    if (this.good_quality_student[this.state.alunoChat_select.id] && this.props.processo.good_quality == true) {
                                                        this.setGoodQualityStudent(this.state.alunoChat_select.id, false);
                                                        this.socket.emit("good_quality", { good: false, aluno_id: this.state.alunoChat_select.id, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id });
                                                    }
                                                    this.fullscreen_ref.current.srcObject = null;
                                                    this.setState({ full_screen_open: false, aluno_fullscreen: -1, })
                                                    let keys = Object.keys(this.list_peers);
                                                    for (let i = 0; i < keys.length; i++) {
                                                        this.list_peers[keys[i]].close();
                                                    }
                                                    for (let i = 0; i < Object.keys(this.state.sala_select.alunos).length; i++) {
                                                        if (this.state.sala_select.alunos[Object.keys(this.state.sala_select.alunos)[i]].videoRef.current != null) {
                                                            this.state.sala_select.alunos[Object.keys(this.state.sala_select.alunos)[i]].desconectado = true;
                                                            this.state.sala_select.alunos[Object.keys(this.state.sala_select.alunos)[i]].videoRef.current.srcObject = null;
                                                        }

                                                    }
                                                    this.socket.emit('change_room', { name: 'Admin', sala_id: null, salas_ids: [], last_sala: this.state.sala_select.id, last_salas_ids: this.getSocketSubscribedRoomIds(), faculdade_id: this.props.faculdade.id, processo_id: this.state.current_processo_id, admin_id: this.admin_id });

                                                    this.props.changeShowCall(true)
                                                    // this.finishExam();
                                                }} type="button" id="finalizar" className="btn btn-outline-info btn-lg waves-effect waves-light"
                                                >Entrar em chamada<i className='mdi mdi-call-made'></i></button>}

                                            </div>}




                                        </div>
                                    </div>}
                                </div>

                                <div className="row" style={{ margin: 0 }}>
                                    {/* {this.props.processo.type_fiscalization == 'image' && <div className="col-12 ">
                                        {this.props.socket != null && <div style={{ zIndex: 3000, width: '100%' }}> <Chat closeChat={() => {
                                            this.setState({ show_modal_chat_geral: false });
                                        }} alunoChat_select={this.state.alunoChat_select} show_modal_chat_geral={this.state.show_modal_chat_geral} online={this.state.number_online} alunos={this.state.alunos_m} admin_id={this.admin_id} comunicados={this.state.comunicados} mudarState={(data) => {
                                            let state = {}
                                            if (data.alunos != undefined) state.alunos_m = data.alunos;
                                            if (data.comunicados != undefined) state.comunicados = data.comunicados;

                                            this.setState(state);

                                        }} />
                                            <br />
                                            <br />

                                        </div>}
                                    </div>} */}
                                    <div className={(this.state.list_open != false ? 'chat_individual_open' : 'chat_individual_close') + ' fiscal-side-drawer fiscal-student-list-drawer'} style={{ position: 'fixed', zIndex: 1000, maxWidth: 500, top: 0, bottom: 0, width: 380 }}>
                                        <ListStudents
                                            full_screen_open={this.state.full_screen_open}
                                            aluno_fullscreen={this.state.aluno_fullscreen}
                                            list_open={this.state.list_open}
                                            goFullScreen={(aluno) => {
                                                this.setState({ full_screen_open: true, aluno_fullscreen: aluno.id, alunoChat_select: { ...this.state.alunos_m[aluno.id] } });
                                                this.fullscreen_ref.current.srcObject = this.state.sala_select.alunos[aluno.id].videoRef.current.srcObject;
                                            }}
                                            setListOpen={(e) => {
                                                this.setState({ list_open: e })
                                            }}
                                            sala_select={this.state.sala_select}
                                            alunos_m={this.state.alunos_m}
                                            number_online={this.state.number_online}
                                            mudarState={(data) => {
                                                let state = {}
                                                if (data.alunos_m != undefined) state.alunos_m = data.alunos_m;

                                                this.setState(state);

                                            }}
                                        />
                                    </div>

                                    {this.state.show_notification && <div style={{ position: 'fixed', bottom: '20px', right: '10px', zIndex: 99, width: '300px', display: 'flex', flexDirection: 'column-reverse', whiteSpace: 'pre-wrap' }}
                                        id="msg_notifi">
                                        {Object.values(this.state.mensagens_notificacao).map((item, id) => (

                                            <div onClick={(e) => {
                                                this.removeNotificacao(item.id)
                                                this.setState({ aluno_select_id: item.sender_id, show_modal_chat_geral: true });
                                            }} key={id} className="alert alert-success bg-success text-white border-0 alert-dismissible fade show d-flex" role="alert" style={{ cursor: 'pointer' }}>
                                                <div style={{ marginRight: 10 }}>
                                                    <button onClick={(e) => { e.stopPropagation(); this.removeNotificacao(item.id) }} type="button" className="close" data-dismiss="alert" aria-label="Close">
                                                        <span aria-hidden="true">×</span>
                                                    </button>
                                                </div>
                                                <div>

                                                    <strong>Nova mensagem Sala {item.sala_number}</strong>
                                                    <p style={{ margin: 0 }}>Candidato: {item.name}</p>
                                                </div>

                                            </div>
                                        ))}
                                        {Object.values(this.state.validacao_notificacao).map((item, id) => (

                                            <div onClick={(e) => {
                                                if (this.state.loading_sala === true || this.state.sala_select.id==item.sala_id) {
                                                    this.removeNotificacaoValidacao(item.id)
                                                    return;
                                                }
                                                const processRoom = this.findProcessRoomBySalaId(item.sala_id);
                                                if (processRoom != null) {
                                                    if (processRoom.processo.id == this.state.current_processo_id) {
                                                        const sala_new = this.state.salas.filter((item2) => item2.id == item.sala_id)[0];
                                                        if (sala_new != null) {
                                                            this.selectRoom(sala_new);
                                                        }
                                                    } else {
                                                        this.selectProcess(processRoom.processo, processRoom.sala);
                                                    }
                                                }

                                                this.removeNotificacaoValidacao(item.id)
                                            }} key={id} className="alert alert-warning bg-warning text-white border-0 alert-dismissible fade show d-flex" role="alert" style={{ cursor: 'pointer' }}>
                                                <div style={{ marginRight: 10 }}>
                                                    <button onClick={(e) => { e.stopPropagation(); this.removeNotificacaoValidacao(item.id) }} type="button" className="close" data-dismiss="alert" aria-label="Close">
                                                        <span aria-hidden="true">×</span>
                                                    </button>
                                                </div>
                                                <div>

                                                    <strong>Novo pedido de validação </strong>
                                                    <p style={{ margin: 0 }}>Sala {item.sala_number}</p>
                                                </div>

                                            </div>
                                        ))}
                                    </div>}

                                    {(this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && <div className="col-12 fiscal-chat-modal" hidden={this.state.show_modal_chat_geral == false} style={{
                                        position: 'fixed',
                                        right: 0,
                                        bottom: 0,
                                        left: 0,
                                        top: 0,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        // background: 'rgba(0,0,0,0.4)',
                                        zIndex: 2000
                                    }}>


                                        {this.props.socket != null && <div className="fiscal-chat-modal-content" style={{ zIndex: 3000, width: '100%' }}> <Chat closeChat={() => {
                                            this.setState({ show_modal_chat_geral: false });
                                        }}
                                            show_chat_meet={this.state.show_chat_meet}
                                            setState={(e) => {
                                                this.setState(e)
                                            }}
                                            chat_open_geral={this.state.chat_open_geral}
                                            aluno_select_id={this.state.aluno_select_id}
                                            removeNotificacao={this.removeNotificacao}
                                            removeNotificacaoValidacao={this.removeNotificacaoValidacao}
                                            validacao_notificacao={this.state.validacao_notificacao}
                                            salas_numbers={this.state.salas_numbers}
                                            clearTimeout={(id) => {
                                                let loadings_pause = { ...this.props.loadings_pause }
                                                loadings_pause[id] = false;
                                                clearTimeout(this.timeout_request[id])
                                                let additional = {}
                                                if (this.state.requestSelect?.id == id) {
                                                    additional.show_modal_request = false;
                                                }
                                                this.setState({ loadings_pause, ...additional })
                                            }}
                                            video_blink={this.state.video_blink} video_blink_movement={this.state.video_blink_movement} alunoChat_select={this.state.alunoChat_select} show_modal_chat_geral={this.state.show_modal_chat_geral} online={this.state.number_online} alunos={this.state.alunos_m} admin_id={this.admin_id} comunicados={this.state.comunicados} mudarState={(data) => {
                                                let state = {}
                                                if (data.alunos != undefined) state.alunos_m = data.alunos;
                                                if (data.comunicados != undefined) state.comunicados = data.comunicados;
                                                if (data.video_blink != undefined) state.video_blink = data.video_blink;
                                                if (data.video_blink_movement != undefined) state.video_blink_movement = data.video_blink_movement;


                                                this.setState(state);

                                            }} /></div>}

                                        <div onClick={() => {
                                            this.setState({ show_modal_chat_geral: false });
                                        }}
                                            style={{
                                                position: 'absolute',
                                                right: 0,
                                                bottom: 0,
                                                left: 0,
                                                top: 0,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                background: 'rgba(0,0,0,0.4)',
                                                zIndex: 2000
                                            }}
                                        >
                                        </div>

                                    </div>}
                                    {this.props.socket != null && this.props.processo.chat_type != 'none' && <div className={(this.props.chat_open != -1 ? 'chat_individual_open' : 'chat_individual_close') + ' fiscal-side-drawer fiscal-chat-drawer'} style={{ position: 'fixed', zIndex: 10000, maxWidth: 420, top: 0, bottom: 0, width: 380 }}>
                                        <ChatIndividual
                                            send_message={(m) => this.send_message(m)}
                                            loadings_pause={this.state.loadings_pause}
                                            sendReceive={() => {
                                                this.sendReceive(this.state.alunoChat_select);
                                            }}
                                            chat_open={this.props.chat_open} aluno_select={this.state.alunoChat_select} online={this.state.number_online} alunos={this.state.alunos_m} admin_id={this.admin_id} comunicados={this.state.comunicados} mudarState={(data) => {
                                                let state = {}
                                                if (data.alunos != undefined) state.alunos_m = data.alunos;
                                                if (data.comunicados != undefined) state.comunicados = data.comunicados;
                                                if (data.request != undefined) state.requestSelect = data.request;
                                                if (data.request != undefined) state.show_modal_request = data.show_modal_request;



                                                this.setState(state);

                                            }} />
                                    </div>}

                                    <div className="col-12 col-md-6 d-flex justify-content-center">
                                        <ReportAction setState={(e) => {
                                            this.setState(e);
                                        }} show_modal_action={this.state.show_modal_action} candidatos={this.state.candidatos} sala={this.state.sala_select} candidato_select={this.state.candidato_selectAcao} />
                                    </div>
                                    <SolicitacaoModal
                                        loadings_pause={this.state.loadings_pause}

                                        sendRequestResponse={(data) => {
                                            let loadings_pause = { ...this.state.loadings_pause }
                                            loadings_pause[data.id] = true;
                                            this.setState({ loadings_pause })
                                            console.log('request dada', data)
                                            this.props.socket.emit('request_pause_response', { ...data });
                                            this.timeout_request[data.id] = setTimeout(() => {
                                                let loadings_pause = { ...this.state.loadings_pause }
                                                loadings_pause[data.id] = false;
                                                this.setState({ loadings_pause, message_warning: 'Não foi possível responder a solicitação do candidato ' + data.name + ' da Sala ' + data.sala_numero });
                                            }, 10000);
                                        }}
                                        request={this.state.requestSelect} setState={(e) => {
                                            this.setState(e);
                                        }} show_modal_request={this.state.show_modal_request} sala={this.state.sala_select} candidato_select={this.state.alunoChat_select} />


                                    <ValidationModal
                                        loadings_request_validations={this.state.loadings_request_validations}
                                        number_online={this.state.number_online}
                                        onClose={(id) => {
                                            if (this.good_quality_student[id] && this.props.processo.good_quality == true) {
                                                this.setGoodQualityStudent(id, false);
                                                this.socket.emit("good_quality", { good: false, aluno_id: id, faculdade_id: this.props.faculdade.id, admin_id: this.admin_id });
                                            }
                                        }}
                                        alter_video={(aluno) => this.alter_video(aluno)}
                                        good_quality_student_alter={(aluno) => this.good_quality_student_alter(aluno)}
                                        loading_alter_video={this.state.loading_alter_video}
                                        alunos_m={this.state.alunos_m}
                                        setState={(e) => {
                                            this.setState(e);
                                        }} open_validation_modal={this.state.open_validation_modal} sala={this.state.sala_select} validation_student_id={this.state.validation_student_id} />




                                </div>
                            </div>
                        </div>
                    </div>
                    <SweetAlert
                        warning
                        title={'Aviso!'}
                        onConfirm={() => this.setState({ message_warning: null })}
                        show={this.state.message_warning != null}
                        confirmBtnText='Entendi'
                        confirmBtnBsStyle="danger"
                    >
                        {this.state.message_warning}
                    </SweetAlert>

                    {this.props.show_call && <MeetingRoom
                        changeStudent={(candidato) => {
                            let candidatos = { ...this.state.alunos_m }
                            candidatos[candidato.id] = candidato;

                            this.setState({ alunos_m: candidatos });
                        }}
                        entrevistas={[]}
                        changeShowChatMeet={(e) => {
                            this.setState({ show_chat_meet: e });
                            if (e == true) {
                                let aluno = this.state.alunoChat_select;
                                if (aluno != undefined) {
                                    this.sendReceive(aluno);
                                }
                            }
                        }}
                        send_message={(m) => this.send_message(m)}
                        getAdminId={() => this.admin_id} processo={this.props.processo} number_online={this.state.number_online} closeCall={() => {
                            this.props.changeShowCall(false);
                            this.socket.emit('change_room', { name: 'Admin', sala_id: this.state.sala_select.id, salas_ids: this.getSocketSubscribedRoomIds(), last_sala: this.state.sala_select.id, last_salas_ids: this.getSocketSubscribedRoomIds(), faculdade_id: this.props.faculdade.id, processo_id: this.state.current_processo_id, admin_id: this.admin_id });

                            this.setState({ alunoChat_select: {} })
                        }}
                        students={Object.values(this.state.alunos_m)}
                        get_messages_from_student={(id) => this.get_messages_from_student(this.state.alunoChat_select.id)}
                        id_candidato={this.state.alunoChat_select?.id}
                        student={this.state.alunoChat_select} />}

                </div>}
                {this.state.loading_screen == true && <Loader title={t.loading_data} description={t.loading_environment} />}
            </div>


        );
    }


}

const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
        faculdade: state.AppReducer.faculdade,
        processo: state.AppReducer.processo,
        user: state.AppReducer.user,
        socket: state.AppReducer.socket,
        chat_open: state.AppReducer.chat_open,
        show_call: state.AppReducer.show_call,
    }
);

export default connect(mapsStateToProps, { changeConnect, mudarUser, logout, mudarProcesso, mudarSocket, mudarSalaScreen, mudarChatOpen, changeShowCall })(Sala);
